<template lang="html">
    <div id="meetInfo"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <meetBar v-if="meetBarOnOff" :tags="tags" :title="title"
                 :subTitle="subTitle"
                 :data="data"
                 :btnSave="false"
                 :btnBack="true"
                 :btnAgree="agreedOnOff"
                 :btnRefuse="refusedOnOff"
                 :btnSubmit="submitOnOff"
                 :complete="completeOnOff"
                 :btnDelete="deleteOnOff"
                 @btnDeleteClick="btnDeleteClick"
                 @btnRefuseClick="btnRefuseClick"
                 @btnAgreeClick = "btnAgreeClick"
                 @btnSubmitClick = "handleSubmitClick"
                 @btnCompleteClick = "handleCompleteClick"
                 @btnSaveClick="handleSaveClick"  @btnBackClick="handleBackClick"/>
        <div style="height: 100%">
            <div style="width: 70%;float: left">
                <el-tabs v-model="activeName" @tab-click="handleClickList" id="tabs_meetinfg">
<!--                    会议信息-->
                    <el-tab-pane label="会议信息" name="information">
                        <!-- 地图-->
                        <div v-if="isShowMap" :style="{width:'100%',height:'290px'}"
                             style="text-align: center;position: relative" >
                            <vue_map v-if="onoffMap" :data="data" :saveOnOff="saveOnOff"
                                     :saveManageOnOff="saveManageOnOff"  :fatherMethod="init"></vue_map>
                        </div>
                        <div class="message" style="margin-top: 20px;">
                            <el-form ref="formlist" :model="meetInfo">
                                <el-row style="margin-top:18px">
                                    <el-col :span="4"  style="font-size: 14px;font-weight: bold">所属辖区</el-col>
                                    <el-col :span="16" style="font-size: 14px;color: #4A90E2;padding-left:5%;
                                    border:1px solid transparent">
                                        {{meetInfo.territory_name}}</el-col>
                                    <el-col v-if="saveOnOff && saveManageOnOff" :span="4"
                                            style="font-size: 14px;color: #FF9901;
                                    cursor: pointer;text-align: right"><span
                                            @click="openUpdatecord">编辑</span></el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4"  style="font-size: 14px;font-weight: bold">类型</el-col>
                                    <el-col :span="16" style="font-size: 14px;color: #4A90E2;padding-left:5%;
                                    border:1px solid transparent">
                                        {{meetInfo.value1}}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4"  style="font-size: 14px;font-weight: bold">名称</el-col>
                                    <el-col :span="20" style="font-size: 14px;color: #4A90E2;padding-left:5%">{{meetInfo.campaign_name}}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4" style="font-size: 14px;font-weight: bold">开始时间</el-col>
                                    <el-col :span="20" style="font-size: 14px;color: #4A90E2;padding-left:5%">{{meetInfo.start_time|timeFormat}}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4" style="font-size: 14px;font-weight: bold">结束时间</el-col>
                                    <el-col :span="20" style="color: #4A90E2;font-size: 14px;padding-left:5%">{{meetInfo.end_time|timeFormat}}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4"  style="font-size: 14px;font-weight: bold">场所</el-col>
                                    <el-col :span="20" style="font-size: 14px;color: #4A90E2;padding-left:5%">{{meetInfo.location}}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4"  style="font-size: 14px;font-weight: bold">地址</el-col>
                                    <el-col :span="20" style="font-size: 14px;color: #4A90E2;padding-left:5%">{{meetInfo.address}}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4"  style="font-size: 14px;font-weight: bold">计划参会人数</el-col>
                                    <el-col :span="20" style="font-size: 14px;color: #4A90E2;padding-left:5%">{{meetInfo.planned_participants}}</el-col>

                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4" style="font-size: 14px;font-weight: bold">计划会议费用</el-col>
                                    <el-col :span="20" style="font-size: 14px;color: #4A90E2;padding-left:5%">{{meetInfo.planned_expense}}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4" style="font-size: 14px;font-weight: bold">发起人</el-col>
                                    <el-col :span="20" style="color: #4A90E2;font-size: 14px;padding-left:5%">{{meetInfo.last_name}}</el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4"  style="font-size: 14px;font-weight: bold">执行人</el-col>
                                    <el-col :span="20" style="font-size: 14px;color: #4A90E2;padding-left:5%">
                                        <span v-for="(item,j) in teamArray" style="padding:2px 4px; background: #FF9901;color: #ffffff;border-radius: 10%;margin-right: 5px;">{{item.value1}}</span>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4"  style="font-size: 14px;font-weight: bold">产品</el-col>
                                    <el-col :span="20" style="font-size: 14px;color: #4A90E2;padding-left:5%">
                                        <span v-for="(item,j) in meetInfo.productArray" style="padding:2px 4px;
                                        background: #FF9901;color: #ffffff;border-radius: 10%;margin-right: 5px;">{{item.value1}}</span>
                                    </el-col>
                                </el-row>
                                <el-row style="margin-top:18px">
                                    <el-col :span="4"  style="font-size: 14px;font-weight: bold">说明</el-col>
                                    <el-col :span="20" style="font-size: 14px;color: #4A90E2;padding-left:5%">{{meetInfo.comments}}</el-col>
                                </el-row>
                            </el-form>

                        </div>
<!--                        <el-row style="margin-top: 40px">-->
<!--                            <el-col>-->
<!--                                <el-button type="success" size="small" @click="handleExportInfo()" style="float:-->
<!--                                left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;">-->
<!--                                    <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>-->
<!--                                    添加-->
<!--                                </el-button>-->
<!--                            </el-col>-->
<!--                        </el-row>-->
                        <el-table
                                :header-cell-style="{'color':'black','font-size':'15px'}"
                                :data="meetInfo.expenseArray"
                                border
                                style="width: 100%;margin-top: 40px"
                                stripe>
                            <el-table-column
                                    align="center"
                                    type="index"
                                    label="序号"
                                    width="60px">
                            </el-table-column>
                            <el-table-column
                                    width="120"
                                    prop="category_name"
                                    sortable
                                    label="费用类别">
                            </el-table-column>
                            <el-table-column
                                    width="80"
                                    prop="quantity"
                                    sortable
                                    label="数量">
                            </el-table-column>
                            <el-table-column
                                    width="80"
                                    prop="amount"
                                    sortable
                                    label="金额">
                            </el-table-column>
                            <el-table-column
                                    prop="comments"
                                    sortable
                                    label="说明">
                            </el-table-column>
<!--                            <el-table-column-->
<!--                                    fixed="right"-->
<!--                                    label="操作"-->
<!--                                    width="150"-->
<!--                            >-->
<!--                                <template slot-scope="scope">-->
<!--                                    <el-button-->
<!--                                            type="danger" size="small"-->
<!--                                            @click="handleDetail(scope.$index, scope.row)">删除-->
<!--                                    </el-button>-->
<!--                                    <el-button-->
<!--                                            type="warning" size="small"-->
<!--                                            @click="handleExportInfo(scope.$index, scope.row)">详情-->
<!--                                    </el-button>-->
<!--                                </template>-->
<!--                            </el-table-column>-->
                        </el-table>
<!--                        <pagination :page="page" @changePage="changePageClick"></pagination>-->
                    </el-tab-pane>
<!--                    会议议程-->
                    <el-tab-pane label="会议议程" name="agenda" @click="getMeetingAgenda">
                        <el-row>
                            <el-col>
                                <el-button v-if="saveOnOff&&agendaUpload" type="success" size="small" @click.stop="addAgenda"
                                            @click="agendaBool=true" style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;">
                                    <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                                    添加
                                </el-button>
                            </el-col>
                            <el-col :span="20" v-for="(item,j) in agenda" style="border: 2px solid #e7eaec;margin-top: 10px;">
                                <p style="margin: 15px;"><span style="color: #7ED321;font-size: 16px;">{{item.month+'月'+item.day+'日'}}</span><span style="color: #4D586D;font-size: 20px;margin-left: 10px;">{{item.start+' - '+item.end}}</span><span v-if="editOnOff&&agendaUpload" @click.stop="agendaEditor(item)" @click="agendaBool = true" style="float: right;color: #FF9901;cursor: pointer;">编辑</span></p>
                                <p style="margin: 15px;font-size: 16px;color: #B0B5B9;">{{item.title}}</p>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top: 15px">
                            <el-col style="width: 130px;margin-right: 20px">
                                <el-col v-if="saveOnOff&&agendaUpload" style="width: 130px;height:166px;margin-right: 20px;" :span="6">
                                    <el-upload

                                            ref="uploadFileAgenda"
                                            accept=".jpg,.png,.jpeg"
                                            action="/photos/uploadphoto"
                                            list-type="picture-card"
                                            :on-preview="handlePictureCardPreview"
                                            :on-remove="handleRemove"
                                            :auto-upload="false"
                                            :show-file-list="false"
                                            :on-success="getPhotoIdAgenda"
                                            :before-upload="getUuidAgenda"
                                            :on-change="beforeUploadAgenda"
                                            :data="categoryAgenda"
                                            multiple>

                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </el-col>
                            </el-col>
                           <el-col style="width: calc(100% - 150px)">
                               <el-col  :span="6" style="margin-right: 20px;position: relative;width: 130px;height: 130px;border-radius: 5%;margin-bottom: 20px;" v-for="(item,j) in photoArrayAgenda">
                                   <img id="meetInfo_imgAgenda"
                                           @click="dialogVisibles(item)" :src="item.img"
                                        style="width: 130px;display: block;object-fit: cover;
                                   height:130px;border-radius: 10px;position: absolute"/>
                                   <div id="meetInfo_afterAgenda"
                                        style="width: 130px;height: 130px;position: absolute;top: 0;left: 0;
                                            transition: .2s;cursor: pointer;line-height: 130px;text-align: center;border-radius: 10px;display: flex;justify-content: center;align-items: center">
                                       <span style="display: flex;width: 50px;justify-content: center;align-items: center">
                                             <i class="el-icon-zoom-in" style="color: white;font-size: 18px;float: left"
                                                @click="dialogVisibles(item)"></i>
                                             <i v-if="isDeletePhoto&&agendaUpload" class="el-icon-delete" style="color: white;font-size: 18px;margin-left: 10px"
                                                @click="deleteImgAgenda(item.id)"></i>
                                       </span>

                                   </div>
                               </el-col>
                           </el-col>

                        </el-row>
                    </el-tab-pane>
<!--                    邀请客户-->
                    <el-tab-pane label="邀请客户" name="customers">
                        <customers v-if="customersOnOff" :fatherMethod="init" :activity_id="activity_id"
                                   :meetInfoStatus="meetInfoStatus" :activity_date="data.date"
                                   :isF="data.created_by"
                                   :saveOnOff="saveOnOff&&sceneUpload"></customers>
                    </el-tab-pane>
<!--                    实际参会-->
                    <el-tab-pane label="实际参会" v-if="onoffTabs" name="participation">
                        <el-row>
                            <el-row>
                            <el-col :span="3" style="margin-top:10px;">
                                <span style="">讲者列表</span>
                            </el-col>
                            <el-col :span="20">
                                <el-button v-if="saveOnOff&&sceneUpload" type="success" size="small" @click="addactualBoolModel()"
                                           style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;
                                           margin-bottom: 4px;">
                                    <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                                    添加
                                </el-button>
                            </el-col>
                            </el-row>
                            <el-col
                                    style="border: 1px solid #ededed;width: 350px;height: 100px;margin-top: 10px;margin-right: 15px;position:relative"
                                    v-for="(item,i) in formParticipant.speakerList" :key="i" >
                                <div style="display: inline-block;width: 55px;height: 55px;border-radius: 50px;margin:15px auto 0;">
                                    <img src="../../../assets/images/chat_header_image.png" width="100%" alt="" style="margin-left: 20px">
                                </div>

                                <span style="position: relative;top: -45px;margin-left: 26px">
<!--                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>-->
                     <span style="color: #4D586D;font-size: 15px;">{{item.reference_name}}</span>
                     <span v-if="item.pro_title"
                           style="color: #fff;border: 1px solid;background-color: #ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{item.pro_title}}</span>
                </span>
                                <span
                                        style="float: right;padding-top: 12px" >
                    <span  style="padding-top: 12px;color: #FF9901;margin-right: 10px">{{item.created_name}}</span>
                    <span  @click="delMeetingParticipant(item)"
                           style="color: red;padding-top: 12px;font-size: 15px;padding-right: 10px;cursor:pointer;" v-if="saveOnOff">移除</span>

                </span>
                                <p style="position: relative;left: 86px;width: 262px;top: -40px;margin: 0">
                  <span style="font-size: 13px;color:#B0B5B9" v-if="item.job_title">
                      {{item.job_title}} | {{item.dept_name}}
                  </span>
                                    <span style="height:16px;display: block" v-else>
                  </span>
                                </p>
                                <!--                <div style="width: 262px;margin-top:-35px;float: right" v-if="item.mobile !== ''" >-->
                                <!--                    <img src="../../../../assets/images/tu5.png" alt="" >-->
                                <!--                    <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">-->
                                <!--                                                 {{item.mobile}}-->
                                <!--                                              </span>-->
                                <!--                </div>-->
                                <div style="width: 262px;margin-top:-35px;float: right" >
                    <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">
                                                 {{item.department_name}}
                                              </span>
                                </div>

                                <div style="width: 262px;float: right;margin-top: -16px">
                    <span style="color:#7ED321;font-size: 13px">
<!--                                                    倡导者-->
                    </span>
                                    <span style="color: #4A90E2;font-size: 13px;" :style="{'color': colorFun(item)}">
                                                    {{item | filter_covegr}}
                                                </span>
                                </div>

                                <el-row style="margin-bottom: 10px">
                                </el-row>

                            </el-col>
                        </el-row>
                        <el-row style="margin-top: 20px;" >
                            <el-row>
                            <el-col :span="3" style="margin-top:10px;">
                                <span style="">听众列表</span>
                            </el-col>
                            <el-col :span="20">
                                <el-button v-if="saveOnOff&&sceneUpload" type="success" size="small" @click="addactualBoolModel"
                                           style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;">
                                    <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                                    添加
                                </el-button>
                            </el-col>
                            </el-row>
                            <el-col
                                    style="border: 1px solid #ededed;width: 350px;height: 100px;margin-top: 10px;margin-right: 15px;position:relative"
                                    v-for="(item,i) in formParticipant.audienceList" :key="i" >
                                <div style="display: inline-block;width: 55px;height: 55px;border-radius: 50px;margin:15px auto 0;">
                                    <img src="../../../assets/images/chat_header_image.png" width="100%" alt="" style="margin-left: 20px">
                                </div>

                                <span style="position: relative;top: -45px;margin-left: 26px">
<!--                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>-->
                     <span style="color: #4D586D;font-size: 15px;">{{item.reference_name}}</span>
                     <span v-if="item.pro_title"
                           style="color: #fff;border: 1px solid;background-color: #ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{item.pro_title}}</span>
                </span>
                                <span
                                        style="float: right;padding-top: 12px" >
                    <span  style="padding-top: 12px;color: #FF9901;margin-right: 10px">{{item.created_name}}</span>
                    <span  @click="delMeetingParticipant(item)"
                           style="color: red;padding-top: 12px;font-size: 15px;padding-right: 10px;cursor:pointer;" v-if="saveOnOff">移除</span>

                </span>
                                <p style="position: relative;left: 86px;width: 262px;top: -40px;margin: 0">
                  <span style="font-size: 13px;color:#B0B5B9" v-if="item.job_title">
                      {{item.job_title}} | {{item.dept_name}}
                  </span>
                                    <span style="height:16px;display: block" v-else>
                  </span>
                                </p>
                                <!--                <div style="width: 262px;margin-top:-35px;float: right" v-if="item.mobile !== ''" >-->
                                <!--                    <img src="../../../../assets/images/tu5.png" alt="" >-->
                                <!--                    <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">-->
                                <!--                                                 {{item.mobile}}-->
                                <!--                                              </span>-->
                                <!--                </div>-->
                                <div style="width: 262px;margin-top:-35px;float: right" >
                    <span style="color: #B0B5B9;font-size: 13px;position: relative;top: -2px;">
                                                 {{item.department_name}}
                                              </span>
                                </div>

                                <div style="width: 262px;float: right;margin-top: -16px">
                    <span style="color:#7ED321;font-size: 13px">
<!--                                                    倡导者-->
                    </span>
                                    <span style="color: #4A90E2;font-size: 13px;" :style="{'color': colorFun(item)}">
                                                    {{item | filter_covegr}}
                                                </span>
                                </div>

                                <el-row style="margin-bottom: 10px">
                                </el-row>

                            </el-col>
                        </el-row>
                    </el-tab-pane>
<!--                    现场照片-->
                    <el-tab-pane label="现场照片" v-if="onoffTabs" name="photos">
                        <el-row>
                            <el-col style="width: 130px;margin-right: 20px">
                                <el-col v-if="saveOnOff&&sceneUpload" style="width: 130px;height:166px;margin-right: 20px;" :span="6">
                                    <el-upload
                                            ref="uploadFile"
                                            accept=".jpg,.png,.jpeg"
                                            action="/photos/uploadphoto"
                                            list-type="picture-card"
                                            :show-file-list="false"
                                            :on-preview="handlePictureCardPreview"
                                            :on-remove="handleRemove"
                                            :auto-upload="false"
                                            :on-success="getPhotoId"
                                            :before-upload="getUuid"
                                            :on-change="beforeUpload"
                                            :data="category"
                                            >

                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </el-col>
                            </el-col>
                           <el-col style="width: calc(100% - 150px)">
                               <el-col :span="6" style="margin-right: 20px;position: relative;width: 130px;height: 130px;border-radius: 5%;margin-bottom: 20px;" v-for="(item,j) in photoArray">

                                       <img id="meetInfo_img"  :src="item.img"
                                            style="width: 130px;height: 130px;border-radius: 10px;
                                            position: absolute;display: block;object-fit: cover;"/>
                                   <div id="meetInfo_after"
                                            style="width: 130px;height: 130px;position: absolute;top: 0;left: 0;
                                            transition: .2s;cursor: pointer;line-height: 130px;text-align: center;
                                            border-radius: 10px;display: flex;justify-content: center;align-items: center">
                                       <span style="display: flex;width: 50px;justify-content: center;align-items: center">
                                           <i class="el-icon-zoom-in" style="color: white;float: left;font-size: 18px"
                                              @click="dialogVisibles_now(item)"></i>
                                           <i v-if="item.created_by==user_id&&isDeletePhoto" class="el-icon-delete" style="color: white;margin-left: 10px;font-size: 18px"
                                          @click="deleteImgAgenda_now(item.id)"></i>
                                       </span>

                                   </div>
                               </el-col>
                           </el-col>

                        </el-row>
                    </el-tab-pane>
                </el-tabs>
            </div>
<!--            右侧留言-->
            <div v-if="onoffWritePen"
                 style="min-height: calc(100% - 120px);width: 27%;float: left;border:1px solid #DEDEDE;background: #F4F6F8;margin-top:10px;margin-left:2.8%;border-radius: 8px;">
                <el-row>
                    <el-button @click="openSavePlanModel" v-if="writePenBtnOnOff"
                               :class="['iconfont', 'el-icon-edit-outline',]" size="small"
                               type="primary"
                               style="float:right;height: 32px;padding: 8px 10px;
                           margin-top: 10px;margin-right: 10px;">
                        <i></i>写一笔</el-button>
                </el-row>

                <el-row style="overflow: auto">
                    <el-col v-for="(item,j) in psArray" style="padding: 5%;">
                        <div
                                style="width: 50px;height: 50px;float: left;overflow: hidden;border-radius: 50px;position: relative">
                            <img v-if="item.src" :src="item.src" alt=""
                                 width="100%"
                                 style=" position: absolute;
                                        top:50%;
                                        left:50%;
                                        transform: translate(-50%,-50%);">

                        </div>
                        <div style="float:right;width: calc(100% - 60px)">
                            <p style="margin-top:0%;margin-bottom:0%;color: #4D586D;font-size: 12px">{{item.last_name}}</p>
                            <p :class="['iconfont','el-icon-time',]"
                               style="color: #87909A;margin-top:10px;margin-bottom:0%;font-size: 12px"><i></i>{{
                                item.timestamp | componentFliter}}</p>
                            <p style="white-space:normal;
                        margin-top:10px;margin-bottom:5%;
                        word-break:break-all;overflow:hidden;
                        width:90%;color: #4A4A4A;font-size: 16px">{{item.contents.comments}}</p>
                        </div>
                    </el-col>

                </el-row>
            </div>
        </div>
<!--        写一笔-->
        <el-dialog
                id="travelSavePlanPs"
                :visible.sync="modelSavePlanPs"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div style="">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;padding-top: 8px;font-size: 20px">写一笔
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="savePlanPs()">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="modelSavePlanPs = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top: 20px">
                <el-input type="textarea" v-model="contents"> </el-input>

            </div>
        </el-dialog>
<!--        会议信息-->
        <el-dialog
                :visible.sync="cordBool"
                :close-on-click-modal="false"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">会议信息
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="inputUpdateMeetingInfo">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="closeCord()">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="council" style="margin-top: 20px;">
                    <!-- 地图-->
                    <div :style="{width:'100%',height:'250px'}" style="text-align: center;position: relative"
                         v-if="onoffMaprefresh" >
                        <el-amap-search-box style="position: absolute;top: 10px;left:10px;height: 30px;z-index: 999"
                                            class="search-box"
                                            :search-option="searchOption"
                                            :on-search-result="onSearchResult"></el-amap-search-box>
                        <el-amap vid="amap" :plugin="plugin" class="amap-demo" :center="center" :zoom="zoom" :events='events'>
                            <!-- 点击显示标记 -->
                            <el-amap-marker v-for="(marker, index) in markers" :key="marker.index" :position="marker.position"
                                            :icon="marker.icon" :title="marker.title" :events="marker.events" :visible="marker.visible"
                                            :draggable="marker.draggable" :vid="index"></el-amap-marker>
                        </el-amap>

                    </div>
                    <div style="margin-top: 30px">
                        <el-form ref="formlist" :model="meetInfo" label-width="120px" :disabled="formOnOff"
                                 class="meetInfo_label_info"
                                 :validate-on-rule-change="false" hide-required-asterisk="false">
                            <el-row>
                                <el-col :span="11">
                                    <el-form-item class="meetInfo_star"
                                            label="所属辖区"
                                            :rules="[{ required: true, message: '所属辖区不能为空'}]"
                                            prop="territory_id">
                                        <el-select v-model="meetInfo.territory_id" style="width: 100%" clearable>
                                            <el-option v-for="item in territoryArray" :key="item.territory_id"
                                                       :label="item.territory_name"
                                                       :value="item.territory_id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11" style="float: right;">
                                    <el-form-item class="meetInfo_star"
                                            label="名称"
                                            :rules="[{ required: true, message: '名称不能为空'}]"
                                            prop="campaign_name">
                                        <el-input v-model="meetInfo.campaign_name" placeholder=""></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item class="meetInfo_star"
                                            prop="start_time"
                                            :rules="[{ required: true, message: '开始时间不能为空'}]"
                                            label="开始时间">
                                        <el-date-picker
                                                @change="changePicker"
                                                v-model="meetInfo.start_time"
                                                type="datetime"
                                                format="yyyy-M-d HH:mm"
                                                value-format="yyyy-MM-dd HH:mm"
                                                placeholder=""
                                                style="width: 275px;"
                                                >
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11" style="float: right">
                                    <el-form-item class="meetInfo_star"
                                            prop="end_time"
                                            :rules="[{ required: true, message: '结束时间不能为空'}]"
                                            label="结束时间">
                                        <el-date-picker
                                                v-model="meetInfo.end_time"
                                                type="datetime"
                                                format="yyyy-M-d HH:mm"
                                                value-format="yyyy-MM-dd HH:mm"
                                                placeholder=""
                                                style="width: 275px;"
                                                @change="chooseTimeRange1"
                                                >
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11" style="float: left;">
                                    <el-form-item class="meetInfo_star"
                                            label="类型"
                                            :rules="[{ required: true, message: '类型不能为空'}]"
                                            prop="key">
                                        <el-select v-model="meetInfo.key" placeholder="" style="width: 275px;" clearable>
                                            <el-option
                                                    v-for="item in options_getMeetingList"
                                                    :key="item.key"
                                                    :label="item.value1"
                                                    :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11" style="float: right;">
                                    <el-form-item label="场所" class="meetInfo_star"
                                                  prop="location_name"
                                                  :rules="[{ required: true, message: '场所不能为空'}]"
                                                  >
                                        <el-input v-model="meetInfo.location_name"  placeholder=""></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11" style="float: right">
                                    <el-form-item label="地址">
                                        <el-input v-model="meetInfo.address"  placeholder=""></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item label="计划参会人数">
                                        <el-input-number style="width: 100%;" controls-position="right" :min="0" type="number" v-model="meetInfo.planned_participants"
                                                  placeholder=""></el-input-number>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11" style="float: right">
                                    <el-form-item label="计划会议费用">
                                        <el-input-number style="width: 100%;" controls-position="right" :min="0" type="number" v-model="meetInfo.planned_expense" placeholder=""></el-input-number>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item label="发起人">
                                        <el-input disabled="" v-model="meetInfo.last_name" placeholder=""></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item label="执行人">
                                        <el-select
                                                v-model="teamArrayInfo"
                                                multiple
                                                filterable
                                                allow-create
                                                default-first-option
                                                placeholder=""
                                                style="width: 740px;" clearable>
                                            <el-option
                                                    v-for="item in options_perform"
                                                    :key="item.user_id"
                                                    :label="item.user_name"
                                                    :value="item.user_id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item label="产品">
                                        <el-select
                                                v-model="productArrayInfo"
                                                multiple
                                                filterable
                                                allow-create
                                                default-first-option
                                                placeholder=""
                                                style="width: 740px;" clearable>
                                            <el-option
                                                    v-for="item in options_productArray"
                                                    :key="item.key"
                                                    :label="item.value1"
                                                    :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col>
                                    <el-form-item label="说明">
                                        <el-input
                                                type="textarea"
                                                :rows="2"
                                                placeholder="这里是一些会议说明和描述"
                                                v-model="meetInfo.comments"
                                                style="width: 740px;">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                            <el-row style="margin-top: 10px">
                                <el-col>
                                    <el-button type="success" size="small" @click="handleExportInfo()" style="float:
                                    left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;">
                                        <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                                        添加
                                    </el-button>
                                </el-col>
                            </el-row>
                                <el-table
                                        :data="meetInfo.expenseArray"
                                        :header-cell-style="{'color':'black','font-size':'15px'}"
                                        border
                                        style="width: 100%;margin-top: 20px"
                                        stripe>
                                    <el-table-column
                                            align="center"
                                            type="index"
                                            label="序号"
                                            width="60px">
                                    </el-table-column>
                                    <el-table-column
                                            width="120px"
                                            prop="category_name"
                                            sortable
                                            label="费用类别">
                                    </el-table-column>
                                    <el-table-column
                                            width="80"
                                            prop="quantity"
                                            sortable
                                            label="数量">
                                    </el-table-column>
                                    <el-table-column
                                            width="80"
                                            prop="amount"
                                            sortable
                                            label="金额">
                                    </el-table-column>
                                    <el-table-column
                                            prop="comments"
                                            sortable
                                            label="说明">
                                    </el-table-column>
                                    <el-table-column
                                            fixed="right"
                                            label-class-name="conference_table_cell"
                                            label="操作"
                                            :width="key_id ? 80:160"
                                    >
                                        <template slot-scope="scope">
                                            <div style="text-align: center">
                                                <el-button
                                                        v-if="!scope.row.key_id"
                                                        type="danger" size="small"
                                                        @click="handleDetail(scope.$index, scope.row)">删除
                                                </el-button>
                                                <el-button
                                                        type="warning" size="small"
                                                        @click="handleExportInfo(scope.$index, scope.row)">详情
                                                </el-button>
                                            </div>

                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-row>
                        </el-form>
                    </div>
                </div>
            </div>

        </el-dialog>
<!--        会议议程-->
        <el-dialog
                :visible.sync="agendaBool"
                width="700px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">会议议程
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button v-if="saveOnOff" type="primary" size="small"
                                       @click.stop="inputSaveMeetingAgenda"
                                        @click="">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="closeAgendaBool()">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="agenda" style="margin-top: 20px;">
                    <el-form ref="formlistAgenda" hide-required-asterisk="false" style="margin-left: 110px" :model="agendaEditorList" label-width="15%" :disabled="!saveOnOff">
                        <el-form-item class="meetInfo_star"
                                label="开始时间"
                                :rules="[{ required: true, message: '开始时间不能为空'}]"
                                prop="start_time"
                        >
                            <el-date-picker
                                    v-model="agendaEditorList.start_time"
                                    type="datetime"
                                    placeholder="请选择开始日期"
                                    format="yyyy-M-d HH:mm"
                                    value-format="yyyy-MM-dd HH:mm"
                                    style="width: 70%;margin-left:5%;"
                                    default-time="12:00:00"
                                    :picker-options="pickerOptions0"
                                    @change="chooseTimeRange0">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item class="meetInfo_star"
                                      label="结束时间"
                                      :rules="[{ required: true, message: '结束时间不能为空'}]"
                                      prop="end_time">
                            <el-date-picker
                                    v-model="agendaEditorList.end_time"
                                    type="datetime"
                                    placeholder="请选择截止日期"
                                    format="yyyy-MM-dd HH:mm"
                                    value-format="yyyy-MM-dd HH:mm"
                                    style="width: 70%;margin-left:5%;"
                                    default-time="12:00:00"
                                    :picker-options="pickerOptions1"
                                    @change="chooseTimeRange2">
                            </el-date-picker>
                        </el-form-item>
<!--                        <el-form-item label="讲者" >-->
<!--                            <el-input v-model="agendaEditorList.speaker" placeholder="请填写讲者"style="width: 70%;margin-left:5%;" ></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item label="会议内容" >
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="会议标题"
                                    v-model="agendaEditorList.title"
                                    style="width: 70%;margin-left:5%;">
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-dialog>
<!--        实际参会客户-->
<!--        <el-dialog-->
<!--                :visible.sync="actualBool"-->
<!--                width="900px"-->
<!--                :show-close="false"-->
<!--                style="vertical-align: center;: #FFF9F3">-->
<!--            <div>-->
<!--                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">-->
<!--                    <el-col :span="12">-->
<!--                        <div style="color: #3998F7;font-size: 26px">实际参会客户-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :span="12">-->
<!--                        <div align="right">-->
<!--                            <el-button type="primary" size="small" @click="saveActualBool()">-->
<!--                                保存-->
<!--                            </el-button>-->
<!--                            <el-button type="danger" size="small" @click="closeActualBool()">-->
<!--                                关闭-->
<!--                            </el-button>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                </el-row>-->
<!--                <div id="actual" style="margin-top: 20px;">-->
<!--                    <el-row>-->
<!--                        <el-col :span="11" style="border-right: 1px solid #979797;height:380px;overflow: auto">-->
<!--                            <el-col :span="23" style="border: 1px solid #979797;margin-bottom: 10px;" v-for="item,i-->
<!--                            in formParticipant.instutionsList" :key="i"-->
<!--                                    @click.native="getDeptList(item.institution_id)">-->
<!--                                <p style="margin: 10px 10px;font-weight: bold;font-size: 14px;">{{item-->
<!--                                    .institution_name}}<span-->
<!--                                            style="color: #FF9901;float: right"> [已选：{{item.selectPeople_num}}人]</span></p>-->
<!--                                <p style="margin: 0px 10px;margin-bottom: 34px;">-->
<!--                                    <el-col :span="22" style="font-size: 13px; color: #B0B5B9;border: 1px solid transparent">-->
<!--                                        {{item.address}}-->
<!--                                    </el-col>-->
<!--                                    <el-col :span="2">-->
<!--                                        <i :class="['iconfont', 'el-icon-arrow-right']" style="color: #979797;float: right"></i>-->
<!--                                    </el-col>-->
<!--                                </p>-->
<!--                                <p style="margin:15px 10px;color: #7ED321;">-->
<!--                                    <span style="display: inline-block;width: 56px">{{item.institution_grade}}</span>-->
<!--                                    <span> | </span>-->
<!--                                    <span>医务人员总数：{{item.hcps}}人</span>-->
<!--                                    <span style="color: #3b99f7;float: right">目标客户{{item.target_num}}人</span>-->
<!--                                </p>-->
<!--                            </el-col>-->
<!--                        </el-col>-->
<!--                        <el-col :span="13" style="height:380px;overflow: auto">-->
<!--                            <el-tabs v-model="activeDepart" @tab-click="handleDepart"-->
<!--                                     style="margin-left: 30px;margin-top: -12px;padding-right: 10px">-->
<!--                                <el-tab-pane :label="obj.dept_name" :name="obj.dept_id" v-for="obj,i in-->
<!--                                formParticipant.instutionsDeptList" :key="i">-->
<!--                                    <el-row>-->
<!--                                        <el-col style="border: 1px solid #ededed;margin-bottom: 15px;-->
<!--                                        position: relative;height: 100px;display:flex;"-->
<!--                                                v-for="objHcp,j in formParticipant.instutionsHcpList"-->
<!--                                                :key="j">-->
<!--                                            <div style="width:80px;height: 100%">-->
<!--                                                <img src="../../../assets/images/chat_header_image.png" width="100%" alt=""-->
<!--                                                     style="position: relative;width: 55px;height: 55px;top: 10px;left: 10px;-->
<!--                                            border-radius:50px">-->
<!--                                            </div>-->
<!--                                            <div style="width: 60%;height: 100%">-->
<!--                                                 <span style="margin-top: 12px;display: block">-->
<!--&lt;!&ndash;                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>&ndash;&gt;-->
<!--                                                 <span style="color: #4D586D;font-size: 15px;">{{objHcp.hcp_name}}</span>-->
<!--                                                 <span-->
<!--                                                         style="color: #fff;border: 1px solid;background-color:#ff9901;border: 1px solid #ff9901;                                                   border-radius:5px;font-size: 11px;padding: 0 6px">{{objHcp.pro_title}}</span>-->
<!--                                            </span>-->

<!--                                                <p style="margin: 8px 0 5px">-->
<!--                                              <span style="font-size: 13px;color:#B0B5B9">-->
<!--                                                  {{objHcp.job_title}} | {{objHcp.dept_name}}-->
<!--                                              </span>-->
<!--                                                </p>-->
<!--                                                <div style="font-size: 13px;color:#B0B5B9;margin-bottom: 5px"-->
<!--                                                     v-if="objHcp.mobile !== ''" >-->
<!--                                                    <img src="../../../assets/images/tu5.png" alt="" style="position: relative;top: 2px">-->
<!--                                                    <span style="">{{objHcp.mobile}}</span>-->
<!--                                                </div>-->
<!--                                                <div v-else style="height: 20px;width:100%"></div>-->
<!--                                                <div style="">-->
<!--                                                <span style="color:#7ED321;font-size: 13px">-->
<!--&lt;!&ndash;                                                    倡导者&ndash;&gt;-->
<!--                                                </span>-->
<!--                                                <span  :style="{'color': colorFun(objHcp)}" style="font-size: 13px;">-->
<!--                                                    {{objHcp | filter_covegr}}-->
<!--                                                </span>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <el-col :span="4" style="border: 1px solid #ededed;background: rgba(74,144,226,0.1);width: 100px; height: 100%;position: absolute;top:0;right:0;">-->
<!--                                                <p style="text-align: center;margin-top: 35px;">-->
<!--                                                    <span style="color: #FF9901;margin-right: 7px;">讲者</span>-->
<!--                                                    <span style="color: #4A90E2;margin-left: 7px;">听众</span></p>-->
<!--                                                <p style="text-align: center;" v-if="objHcp.onoff === ''">-->
<!--                                                    <span style="margin-right: 8px"-->
<!--                                                          @click.stop="DepartClickHcp(objHcp,'uncheck1')">-->
<!--                                                        <img src="../../../assets/images/hcpCheck.png" width="24"-->
<!--                                                             height="24"/>-->
<!--                                                    </span>-->
<!--                                                    <span style="margin-left: 8px;"-->
<!--                                                          @click.stop="DepartClickHcp(objHcp,'uncheck2')">-->
<!--                                                        <img src="../../../assets/images/hcpNoCheckB.png" width="24"-->
<!--                                                             height="24"/>-->
<!--                                                    </span>-->
<!--                                                </p>-->
<!--                                                <p style="text-align: center;" v-else-if="objHcp.onoff === 'SPEAKER'">-->
<!--                                                    <span style="margin-right: 8px;"-->
<!--                                                          @click.stop="DepartClickHcp(objHcp,'spcheck')">-->
<!--                                                        <img  v-if='' src="../../../assets/images/speakers.png" width="24"-->
<!--                                                              height="24"/>-->
<!--                                                    </span>-->
<!--                                                    <span style="margin-left: 8px;"-->
<!--                                                          @click.stop="DepartClickHcp(objHcp,'uncheck2')">-->
<!--                                                        <img v-if='' src="../../../assets/images/hcpNoCheckB.png" width="24"-->
<!--                                                             height="24"/>-->
<!--                                                    </span>-->
<!--                                                </p>-->
<!--                                                <p style="text-align: center;" v-else-if="objHcp.onoff ==='AUDIENCE'">-->
<!--                                                    <span style="margin-right: 8px;"-->
<!--                                                          @click.stop="DepartClickHcp(objHcp,'uncheck1')">-->
<!--                                                        <img  v-if='' src="../../../assets/images/hcpCheck.png" width="24"-->
<!--                                                              height="24"/>-->
<!--                                                    </span>-->
<!--                                                    <span style="margin-left: 8px;"-->
<!--                                                          @click.stop="DepartClickHcp(objHcp,'aucheck')">-->
<!--                                                        <img v-if='' src="../../../assets/images/audience.png" width="24"-->
<!--                                                             height="24"/>-->
<!--                                                    </span>-->
<!--                                                </p>-->
<!--                                            </el-col>-->
<!--                                        </el-col>-->

<!--                                    </el-row>-->
<!--                                </el-tab-pane>-->

<!--                            </el-tabs>-->
<!--                        </el-col>-->
<!--                    </el-row>-->
<!--                    <el-card class="box-card">-->
<!--                              <span  v-for="selectItem,i in concatListCopy"-->
<!--                                     style="display: inline-block;-->
<!--                                      background: #FF9901;-->
<!--                                      color: white;padding: 2px 6px;-->
<!--                                      margin-top: 6px;-->
<!--                                      margin-right: 10px;-->
<!--                                      border-radius: 6px;-->
<!--                                      line-height: 25px;font-size: 12px">-->
<!--                                  {{ selectItem | filterSelectItem }}-->
<!--                                  </span>-->
<!--                    </el-card>-->
<!--                </div>-->
<!--            </div>-->

<!--        </el-dialog>-->
        <el-dialog
                :visible.sync="actualBool"
                width="900px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="6">
                        <div style="color: #3998F7;font-size: 22px;padding-top: 5px">实际参会客户
                        </div>
                    </el-col>
                    <el-col :span="12" style="text-align: center">
                        <div>
                            <el-button-group>
                                <el-button :class="{active:selectType=='INSTITUTION'}" @click="checkType('INSTITUTION')" v-if="clientObj.showInstitution">医疗机构</el-button>
                                <el-button :class="{active:selectType=='RETAILSTORE'}" @click="checkType('RETAILSTORE')" v-if="clientObj.showStore">零售终端</el-button>
                                <el-button :class="{active:selectType=='DISTRIBUTOR'}" @click="checkType('DISTRIBUTOR')" v-if="clientObj.showDistributor">分销客户</el-button>
                            </el-button-group>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div align="right">
                            <el-button type="primary" size="small" @click="saveActualBool()">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="closeActualBool()">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div style="margin-top: 20px;" v-if="selectType=='INSTITUTION'">
                    <el-row>
                        <el-col :span="11" style="border-right: 1px solid #979797;height:380px;overflow: auto" >
                            <el-col :span="23" style="border: 1px solid #979797;margin-bottom: 10px;" v-for="(item,i)
                            in formParticipant.instutionsList" :key="i" :style="{backgroundColor:item.select?'#ECF3FC':'#fff'}"
                                    @click.native="getDeptList(item)">
                                <p style="margin: 10px 10px;font-weight: bold;font-size: 14px;">{{item
                                    .institution_name}}<span
                                            style="color: #FF9901;float: right"> [已选：{{item.selectPeople_num}}人]</span></p>
                                <p style="margin: 0px 10px;margin-bottom: 34px;">
                                    <el-col :span="22" style="font-size: 13px; color: #B0B5B9;border: 1px solid transparent">
                                        {{item.address}}
                                    </el-col>
                                    <el-col :span="2">
                                        <i :class="['iconfont', 'el-icon-arrow-right']" style="color: #979797;float: right"></i>
                                    </el-col>
                                </p>
                                <p style="margin:15px 10px;color: #7ED321;">
                                    <span style="display: inline-block;width: 56px">{{item.institution_grade}}</span>
                                    <span> | </span>
                                    <span>医务人员总数：{{item.hcps}}人</span>
                                    <span style="color: #3b99f7;float: right">目标客户{{item.target_num}}人</span>
                                </p>
                            </el-col>
                        </el-col>
                        <el-col :span="13" style="height:380px;overflow: auto">
                            <el-tabs v-model="activeDepart" @tab-click="handleDepart"
                                     style="margin-left: 30px;margin-top: -12px;padding-right: 10px">
                                <el-tab-pane :label="obj.dept_name" :name="obj.dept_id" v-for="(obj,i) in
                                formParticipant.instutionsDeptList" :key="i">
                                    <el-row>
                                        <el-col style="border: 1px solid #ededed;margin-bottom: 15px;
                                        position: relative;height: 100px;display:flex;"
                                                v-for="(objHcp,j) in formParticipant.instutionsHcpList"
                                                :key="j">
                                            <div style="width:80px;height: 100%">
                                                <img src="../../../assets/images/chat_header_image.png" width="100%" alt=""
                                                     style="position: relative;width: 55px;height: 55px;top: 10px;left: 10px;
                                            border-radius:50px">
                                            </div>
                                            <div style="width: 60%;height: 100%">
                                                 <span style="margin-top: 12px;display: block">
<!--                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>-->
                                                 <span style="color: #4D586D;font-size: 15px;">{{objHcp.reference_name}}</span>
                                                 <span style="color: #fff;border: 1px solid;background-color:#ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{objHcp.pro_title}}</span>
                                            </span>

                                                <p style="margin: 8px 0 5px">
                                              <span style="font-size: 13px;color:#B0B5B9">
                                                  {{objHcp.job_title}} | {{objHcp.dept_name}}
                                              </span>
                                                </p>
                                                <div style="font-size: 13px;color:#B0B5B9;margin-bottom: 5px"
                                                     v-if="objHcp.mobile !== ''" >
                                                    <img src="../../../assets/images/tu5.png" alt="" style="position: relative;top: 2px">
                                                    <span style="">{{objHcp.mobile}}</span>
                                                </div>
                                                <div v-else style="height: 20px;width:100%"></div>
                                                <div style="">
                                                <span style="color:#7ED321;font-size: 13px">
<!--                                                    倡导者-->
                                                </span>
                                                    <span  :style="{'color': colorFun(objHcp)}"
                                                           style="">
                                                    {{objHcp | filter_covegr}}
                                                </span>
                                                </div>
                                            </div>
                                            <el-col :span="4" style="border: 1px solid #ededed;background: rgba(74,144,226,0.1);width: 100px; height: 100%;position: absolute;top:0;right:0;">
                                                <p style="text-align: center;margin-top: 25px;margin-bottom: 0">
                                                    <span style="color: #FF9901;margin-right: 7px;">讲者</span>
                                                    <span style="color: #4A90E2;margin-left: 7px;">听众</span></p>
                                                <p style="text-align: center;margin-top: 10px" v-if="objHcp.onoff === ''">
                                                    <span style="margin-right: 8px"
                                                          @click.stop="DepartClickHcp(objHcp,'uncheck1')">
                                                        <img src="../../../assets/images/hcpCheck.png" width="24"
                                                             height="24"/>
                                                    </span>
                                                    <span style="margin-left: 8px;"
                                                          @click.stop="DepartClickHcp(objHcp,'uncheck2')">
                                                        <img src="../../../assets/images/hcpNoCheckB.png" width="24"
                                                             height="24"/>
                                                    </span>
                                                </p>
                                                <p style="text-align: center;" v-else-if="objHcp.onoff === 'SPEAKER'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(objHcp,'spcheck')">
                                                        <img  v-if='' src="../../../assets/images/speakers.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                                    <span style="margin-left: 8px;"
                                                          @click.stop="DepartClickHcp(objHcp,'uncheck2')">
                                                        <img v-if='' src="../../../assets/images/hcpNoCheckB.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                                </p>
                                                <p style="text-align: center;" v-else-if="objHcp.onoff ==='AUDIENCE'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(objHcp,'uncheck1')">
                                                        <img  v-if='' src="../../../assets/images/hcpCheck.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                                    <span style="margin-left: 8px;"
                                                          @click.stop="DepartClickHcp(objHcp,'aucheck')">
                                                        <img v-if='' src="../../../assets/images/audience.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                                </p>
                                            </el-col>
                                        </el-col>

                                    </el-row>
                                </el-tab-pane>

                            </el-tabs>
                        </el-col>
                    </el-row>
<!--                    <el-card class="box-card">-->
<!--                              <span  v-for="(selectItem,i) in concatListCopy"-->
<!--                                     style="display: inline-block;-->
<!--                                      background: #FF9901;-->
<!--                                      color: white;padding: 2px 6px;-->
<!--                                      margin-top: 6px;-->
<!--                                      margin-right: 10px;-->
<!--                                      border-radius: 6px;-->
<!--                                      line-height: 25px;font-size: 12px">-->
<!--                                  {{ selectItem | filterSelectItem }}-->
<!--                                  </span>-->
<!--                    </el-card>-->
                </div>
                <div style="margin-top: 20px;" v-if="selectType=='RETAILSTORE'">
                    <el-row>
                        <el-col :span="11" style="border-right: 1px solid #979797;height:380px;overflow: auto" >
                            <el-col :span="23" style="border: 1px solid #979797;margin-bottom: 10px;" v-for="(item,i)
                            in formParticipant.retailStoreList" :key="i" :style="{backgroundColor:item.select?'#ECF3FC':'#fff'}"
                                    @click.native="getStorePeopleList(item)">
                                <p style="margin: 10px 10px;font-weight: bold;font-size: 14px;position: relative"><span style="display:inline-block;width: 75%;line-height: 15px">{{item.store_name}}</span>
                                    <span style="color: #FF9901;display: inline-block;position: absolute;top: 0px;right: 0px"> [已选：{{item.selectPeople_num}}人]</span>
                                </p>
                                <p style="margin: 0px 10px;margin-bottom: 34px;">
                                    <el-col :span="22" style="font-size: 13px; color: #B0B5B9;border: 1px solid transparent">
                                        {{item.address}}
                                    </el-col>
                                    <el-col :span="2">
                                        <i :class="['iconfont', 'el-icon-arrow-right']" style="color: #979797;float: right"></i>
                                    </el-col>
                                </p>
                                <p style="margin:15px 10px;color: #7ED321;">
                                    <span style="display: inline-block;width: 56px">{{item.retailstore_grade}}</span>
                                    <span> | </span>
                                    <span>店员人数：{{item.clerk_num}}人</span>
                                    <span style="color: #3b99f7;float: right">本月巡店{{item.inspection_num}}次</span>
                                </p>
                            </el-col>
                        </el-col>
                        <el-col :span="13" style="height:380px;overflow: auto">
                            <el-row style="margin-left: 30px">
                                <el-col style="border: 1px solid #ededed;margin-bottom: 15px;
                                        position: relative;height: 80px;display:flex;"
                                        v-for="(obj,j) in formParticipant.retailStoreClerk"
                                        :key="j">
                                    <div style="width:80px;height: 100%">
                                        <img src="../../../assets/images/chat_header_image.png" width="100%" alt=""
                                             style="position: relative;width: 55px;height: 55px;top: 10px;left: 10px;
                                            border-radius:50px">
                                    </div>
                                    <div style="width: 60%;height: 100%">
                                              <span style="margin-top: 12px;display: block">
<!--                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>-->
                                                 <span style="color: #4D586D;font-size: 15px;">{{obj.reference_name}}</span>
                                                   <span style="color: #fff;border: 1px solid;background-color:#ff9901;border: 1px solid #ff9901;border-radius:5px;font-size: 11px;padding: 0 6px">{{obj.job_title}}</span>
                                            </span>
                                        <div style="font-size: 13px;color:#B0B5B9;margin-top: 16px"
                                             v-if="obj.mobile !== ''" >
                                            <img src="../../../assets/images/tu5.png" alt="" style="position: relative;top: 3px">
                                            <span style="">{{obj.mobile}}</span>
                                        </div>
                                        <div v-else style="height: 20px;width:100%"></div>
                                    </div>
                                    <el-col :span="4" style="border: 1px solid #ededed;background: rgba(74,144,226,0.1);width: 100px; height: 100%;position: absolute;top:0;right:0;">
                                        <p style="text-align: center;margin-top: 16px;margin-bottom: 0">
                                            <span style="color: #FF9901;margin-right: 7px;">讲者</span>
                                            <span style="color: #4A90E2;margin-left: 7px;">听众</span></p>
                                        <p style="text-align: center;margin-top: 10px" v-if="obj.onoff === ''">
                                                    <span style="margin-right: 8px"
                                                          @click.stop="DepartClickHcp(obj,'uncheck1')">
                                                        <img src="../../../assets/images/hcpCheck.png" width="24"
                                                             height="24"/>
                                                    </span>
                                            <span style="margin-left: 8px;"
                                                  @click.stop="DepartClickHcp(obj,'uncheck2')">
                                                        <img src="../../../assets/images/hcpNoCheckB.png" width="24"
                                                             height="24"/>
                                                    </span>
                                        </p>
                                        <p style="text-align: center;" v-else-if="obj.onoff === 'SPEAKER'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(obj,'spcheck')">
                                                        <img  v-if='' src="../../../assets/images/speakers.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                            <span style="margin-left: 8px;"
                                                  @click.stop="DepartClickHcp(obj,'uncheck2')">
                                                        <img v-if='' src="../../../assets/images/hcpNoCheckB.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                        </p>
                                        <p style="text-align: center;" v-else-if="obj.onoff ==='AUDIENCE'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(obj,'uncheck1')">
                                                        <img  v-if='' src="../../../assets/images/hcpCheck.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                            <span style="margin-left: 8px;"
                                                  @click.stop="DepartClickHcp(obj,'aucheck')">
                                                        <img v-if='' src="../../../assets/images/audience.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                        </p>
                                    </el-col>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
<!--                    <el-card class="box-card">-->
<!--                              <span  v-for="(selectItem,i) in concatListCopy"-->
<!--                                     style="display: inline-block;-->
<!--                                      background: #FF9901;-->
<!--                                      color: white;padding: 2px 6px;-->
<!--                                      margin-top: 6px;-->
<!--                                      margin-right: 10px;-->
<!--                                      border-radius: 6px;-->
<!--                                      line-height: 25px;font-size: 12px">-->
<!--                                  {{ selectItem | filterSelectItem }}-->
<!--                                  </span>-->
<!--                    </el-card>-->
                </div>
                <div style="margin-top: 20px;" v-if="selectType=='DISTRIBUTOR'">
                    <el-row>
                        <el-col :span="11" style="border-right: 1px solid #979797;height:380px;overflow: auto" >
                            <el-col :span="23" style="border: 1px solid #979797;margin-bottom: 10px;" v-for="(item,i)
                            in formParticipant.distributorList" :key="i" :style="{backgroundColor:item.select?'#ECF3FC':'#fff'}"
                                    @click.native="getDistributorContactList(item)">
                                <p style="margin: 10px 10px;font-weight: bold;font-size: 14px;position: relative"><span style="display:inline-block;width: 75%;line-height: 15px">{{item.distributor_name}}</span>
                                    <span style="color: #FF9901;display: inline-block;position: absolute;top: 0px;right: 0px"> [已选：{{item.selectPeople_num}}人]</span>
                                </p>
                                <p style="margin: 0px 10px;margin-bottom: 34px;">
                                    <el-col :span="22" style="font-size: 13px; color: #B0B5B9;border: 1px solid transparent">
                                        {{item.address}}
                                    </el-col>
                                    <el-col :span="2">
                                        <i :class="['iconfont', 'el-icon-arrow-right']" style="color: #979797;float: right"></i>
                                    </el-col>
                                </p>
                                <p style="margin:15px 10px;color: #7ED321;">
                                    <span style="display: inline-block;width: 56px">{{item.distributor_grade}}</span>
                                    <span> | </span>
                                    <span>联系人：{{item.contact_num}}人</span>
                                    <span style="color: #3b99f7;float: right">本月拜访{{item.inspection_num}}次</span>
                                </p>
                            </el-col>
                        </el-col>
                        <el-col :span="13" style="height:380px;overflow: auto">
                            <el-row style="margin-left: 30px">
                                <el-col style="border: 1px solid #ededed;margin-bottom: 15px;
                                        position: relative;height: 80px;display:flex;"
                                        v-for="(obj,j) in formParticipant.distributorContact"
                                        :key="j">
                                    <div style="width:80px;height: 100%">
                                        <img src="../../../assets/images/chat_header_image.png" width="100%" alt=""
                                             style="position: relative;width: 55px;height: 55px;top: 10px;left: 10px;
                                            border-radius:50px">
                                    </div>
                                    <div style="width: 60%;height: 100%">
                                              <span style="margin-top: 12px;display: block">
<!--                                                 <span style="color: #fff;border: #3998f7 1px solid;background-color: #3998f7;padding: 2px 7px">A</span>-->
                                                 <span style="color: #4D586D;font-size: 15px;">{{obj.reference_name}}</span>
                                            </span>
                                        <div style="font-size: 13px;color:#B0B5B9;margin-top: 16px"
                                             v-if="obj.mobile !== ''" >
                                            <img src="../../../assets/images/tu5.png" alt="" style="position: relative;top: 2px">
                                            <span style="">{{obj.mobile}}</span>
                                        </div>
                                        <div v-else style="height: 20px;width:100%"></div>
                                    </div>
                                    <el-col :span="4" style="border: 1px solid #ededed;background: rgba(74,144,226,0.1);width: 100px; height: 100%;position: absolute;top:0;right:0;">
                                        <p style="text-align: center;margin-top: 16px;margin-bottom: 0">
                                            <span style="color: #FF9901;margin-right: 7px;">讲者</span>
                                            <span style="color: #4A90E2;margin-left: 7px;">听众</span></p>
                                        <p style="text-align: center;margin-top: 10px" v-if="obj.onoff === ''">
                                                    <span style="margin-right: 8px"
                                                          @click.stop="DepartClickHcp(obj,'uncheck1')">
                                                        <img src="../../../assets/images/hcpCheck.png" width="24"
                                                             height="24"/>
                                                    </span>
                                            <span style="margin-left: 8px;"
                                                  @click.stop="DepartClickHcp(obj,'uncheck2')">
                                                        <img src="../../../assets/images/hcpNoCheckB.png" width="24"
                                                             height="24"/>
                                                    </span>
                                        </p>
                                        <p style="text-align: center;" v-else-if="obj.onoff === 'SPEAKER'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(obj,'spcheck')">
                                                        <img  v-if='' src="../../../assets/images/speakers.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                            <span style="margin-left: 8px;"
                                                  @click.stop="DepartClickHcp(obj,'uncheck2')">
                                                        <img v-if='' src="../../../assets/images/hcpNoCheckB.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                        </p>
                                        <p style="text-align: center;" v-else-if="obj.onoff ==='AUDIENCE'">
                                                    <span style="margin-right: 8px;"
                                                          @click.stop="DepartClickHcp(obj,'uncheck1')">
                                                        <img  v-if='' src="../../../assets/images/hcpCheck.png"
                                                              width="24"
                                                              height="24"/>
                                                    </span>
                                            <span style="margin-left: 8px;"
                                                  @click.stop="DepartClickHcp(obj,'aucheck')">
                                                        <img v-if='' src="../../../assets/images/audience.png"
                                                             width="24"
                                                             height="24"/>
                                                    </span>
                                        </p>
                                    </el-col>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
<!--                    <el-card class="box-card">-->
<!--                              <span  v-for="(selectItem,i) in concatListCopy"-->
<!--                                     style="display: inline-block;-->
<!--                                      background: #FF9901;-->
<!--                                      color: white;padding: 2px 6px;-->
<!--                                      margin-top: 6px;-->
<!--                                      margin-right: 10px;-->
<!--                                      border-radius: 6px;-->
<!--                                      line-height: 25px;font-size: 12px">-->
<!--                                  {{ selectItem | filterSelectItem }}-->
<!--                                  </span>-->
<!--                    </el-card>-->
                </div>
                <el-card class="box-card" style="margin-top:20px">
                              <span  v-for="(selectItem,i) in concatListCopy"
                                     style="display: inline-block;
                                      background: #FF9901;
                                      color: white;padding: 2px 6px;
                                      margin-top: 6px;
                                      margin-right: 10px;
                                      border-radius: 6px;
                                      line-height: 25px;font-size: 12px">
                                  {{ selectItem | filterSelectItem }}
                                  </span>
                </el-card>
            </div>

        </el-dialog>
<!--        上传现场照片-->
<!--        <el-dialog-->
<!--                :visible.sync="pictureAdd"-->
<!--                width="700px"-->
<!--                :show-close="false"-->
<!--                style="vertical-align: center;: #FFF9F3">-->
<!--            <div>-->
<!--                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">-->
<!--                    <el-col :span="12">-->
<!--                        <div style="color: #3998F7;font-size: 26px">上传现场照片-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :span="12">-->
<!--                        <div align="right">-->
<!--                            <el-button type="primary" size="small" @click.stop="saveMeetingPhoto" @click="pictureAdd = false">-->
<!--                                保存-->
<!--                            </el-button>-->
<!--                            <el-button type="danger" size="small" @click.stop="addDialogClose" @click="pictureAdd = false">-->
<!--                                关闭-->
<!--                            </el-button>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                </el-row>-->
<!--                <div id="pictureAdd" style="margin-top: 20px;">-->
<!--                    <el-form ref="formlist" :model="formlist" label-width="25%">-->
<!--                        <el-form-item label="上传文件" class="a_upload_file">-->
<!--                                <el-upload-->

<!--                                        ref="uploadFile"-->
<!--                                        accept=".jpg,.png,.jpeg"-->
<!--                                        action="/photos/uploadphoto"-->
<!--                                        list-type="picture-card"-->
<!--                                        :on-preview="handlePictureCardPreview"-->
<!--                                        :on-remove="handleRemove"-->
<!--                                        :auto-upload="false"-->
<!--                                        :on-success="getPhotoId"-->
<!--                                        :before-upload="getUuid"-->
<!--                                        :on-change="beforeUpload"-->
<!--                                        :data="category"-->
<!--                                        multiple>-->

<!--                                <i class="el-icon-plus"></i>-->
<!--                            </el-upload>-->
<!--                        <p >你可以上传多张JPG或PNG格式的图片文件, 单个文件大小不能超过20M。</p>-->
<!--                        <p style="color: #4A90E2;font-weight: bold;">请待进度条走到-->
<!--                            100%并出现<i class="el-icon-circle-check" style="color:green;font-size: 16px;margin-left: 5px;margin-right: 5px"></i>之后保存，方为上传成功!-->
<!--                        </p>-->

<!--                        </el-form-item>-->
<!--&lt;!&ndash;                        <el-form-item label="上传照片">&ndash;&gt;-->
<!--&lt;!&ndash;                            <el-upload&ndash;&gt;-->
<!--&lt;!&ndash;                                    &ndash;&gt;-->
<!--&lt;!&ndash;                                    ref="uploadFile"&ndash;&gt;-->
<!--&lt;!&ndash;                                    :auto-upload="false"&ndash;&gt;-->
<!--&lt;!&ndash;                                    action="/photos/uploadphoto"&ndash;&gt;-->
<!--&lt;!&ndash;                                    :before-upload="getUuid"&ndash;&gt;-->
<!--&lt;!&ndash;                                    :on-success="getPhotoId"&ndash;&gt;-->
<!--&lt;!&ndash;                                    :on-change="beforeUpload"&ndash;&gt;-->
<!--&lt;!&ndash;                                    :data="category"&ndash;&gt;-->
<!--&lt;!&ndash;                                    multiple>&ndash;&gt;-->
<!--&lt;!&ndash;                                <i class="el-icon-upload"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>&ndash;&gt;-->
<!--&lt;!&ndash;                            </el-upload>&ndash;&gt;-->
<!--&lt;!&ndash;                        </el-form-item>&ndash;&gt;-->
<!--                    </el-form>-->
<!--                </div>-->
<!--            </div>-->

<!--        </el-dialog>-->
<!--        上传会议议程照片-->
<!--        <el-dialog-->
<!--                :visible.sync="AgendaAdd"-->
<!--                width="700px"-->
<!--                :show-close="false"-->
<!--                style="vertical-align: center;: #FFF9F3">-->
<!--            <div>-->
<!--                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">-->
<!--                    <el-col :span="12">-->
<!--                        <div style="color: #3998F7;font-size: 26px">会议议程照片-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                    <el-col :span="12">-->
<!--                        <div align="right">-->
<!--                            <el-button type="primary" size="small" @click.stop="saveMeetingAgendaPhoto" @click="AgendaAdd = false">-->
<!--                                保存-->
<!--                            </el-button>-->
<!--                            <el-button type="danger" size="small" @click.stop="addDialogClose" @click="AgendaAdd = false">-->
<!--                                关闭-->
<!--                            </el-button>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                </el-row>-->
<!--                <div id="AgendaAdd" style="margin-top: 20px;">-->
<!--                    <el-form ref="formlist" :model="formlist" label-width="25%">-->
<!--                        <el-form-item label="上传文件" class="a_upload_file">-->
<!--                            <el-upload-->

<!--                                    ref="uploadFile"-->
<!--                                    accept=".jpg,.png,.jpeg"-->
<!--                                    action="/photos/uploadphoto"-->
<!--                                    list-type="picture-card"-->
<!--                                    :on-preview="handlePictureCardPreview"-->
<!--                                    :on-remove="handleRemove"-->
<!--                                    :auto-upload="false"-->
<!--                                    :on-success="getPhotoIdAgenda"-->
<!--                                    :before-upload="getUuidAgenda"-->
<!--                                    :on-change="beforeUpload"-->
<!--                                    :data="categoryAgenda"-->
<!--                                    multiple>-->

<!--                                <i class="el-icon-plus"></i>-->
<!--                            </el-upload>-->
<!--                            <p >你可以上传多张JPG或PNG格式的图片文件, 单个文件大小不能超过20M。</p>-->
<!--                            <p style="color: #4A90E2;font-weight: bold;">请待进度条走到-->
<!--                                100%并出现<i class="el-icon-circle-check" style="color:green;font-size: 16px;margin-left: 5px;margin-right: 5px"></i>之后保存，方为上传成功!-->
<!--                            </p>-->

<!--                        </el-form-item>-->
<!--&lt;!&ndash;                        <el-form-item label="上传照片">&ndash;&gt;-->
<!--&lt;!&ndash;                            <el-upload&ndash;&gt;-->
<!--&lt;!&ndash;                                    class="upload-demo"&ndash;&gt;-->
<!--&lt;!&ndash;                                    drag&ndash;&gt;-->
<!--&lt;!&ndash;                                    ref="uploadFile"&ndash;&gt;-->
<!--&lt;!&ndash;                                    :auto-upload="false"&ndash;&gt;-->
<!--&lt;!&ndash;                                    action="/photos/uploadphoto"&ndash;&gt;-->
<!--&lt;!&ndash;                                    :before-upload="getUuidAgenda"&ndash;&gt;-->
<!--&lt;!&ndash;                                    :on-success="getPhotoIdAgenda"&ndash;&gt;-->
<!--&lt;!&ndash;                                    :on-change="beforeUpload"&ndash;&gt;-->
<!--&lt;!&ndash;                                    :data="categoryAgenda"&ndash;&gt;-->
<!--&lt;!&ndash;                                    multiple>&ndash;&gt;-->
<!--&lt;!&ndash;                                <i class="el-icon-upload"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>&ndash;&gt;-->
<!--&lt;!&ndash;                            </el-upload>&ndash;&gt;-->
<!--&lt;!&ndash;                        </el-form-item>&ndash;&gt;-->
<!--                    </el-form>-->
<!--                </div>-->
<!--            </div>-->

<!--        </el-dialog>-->
<!--        费用预估-->
        <el-dialog
                :visible.sync="estimatesBool"
                width="700px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">费用预估
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click=" inputSaveMeetingExpense()">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="closeExpense()">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="estimates" style="margin-top: 20px;">
                    <el-form ref="formlistExpense" :label-position="labelPosition" :model="meetingExpenseModelInfo" hide-required-asterisk="false" label-width="25%" >
                        <el-form-item class="meetInfo_star"
                                label="费用类别"
                                :rules="[{ required: true, message: '费用类别不能为空'}]"
                                prop="category_id">
                            <el-select v-model="meetingExpenseModelInfo.category_id" placeholder="请选择"
                                       style="width: 70%;margin-left:5%;" clearable>
                                <el-option
                                        v-for="item in meetingExpenseSelect"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="数量" >
                            <el-input-number controls-position="right" :min="0" v-model="meetingExpenseModelInfo.quantity" type="number"
                                      style="width: 70%;margin-left:5%;" ></el-input-number>
                        </el-form-item>
                        <el-form-item label="金额" >
                            <el-input-number controls-position="right" :min="0" v-model="meetingExpenseModelInfo.amount" type="number"
                                      style="width: 70%;margin-left:5%;" ></el-input-number>
                        </el-form-item>
                        <el-form-item label="说明" >
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="费用说明"
                                    v-model="meetingExpenseModelInfo.comments"
                                    style="width: 70%;margin-left:5%;">
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-dialog>
<!--        会议议程图片放大-->
        <el-dialog :visible.sync="dialogVisibleImg" class="dialogVisibleUp">
            <img width="100%" :src="dialogSrc" alt="">
        </el-dialog>
<!--        现场照片图片放大-->
        <el-dialog :visible.sync="dialogVisibleImg_now" class="dialogVisibleUp">
            <img width="100%" :src="dialogSrc_now" alt="">
        </el-dialog>

<!--        <el-dialog :visible.sync="dialogVisible" id="dialogVisibleUp">-->
<!--            <img width="100%" :src="dialogImageUrl" alt="">-->
<!--        </el-dialog>-->
    </div>
</template>

<script>
    import meetBar from '../../../components/meetBar'
    import http from '../../../APIService/http'
    import moment from 'moment'
    import pagination from '../../../components/pagination'
    import customers from './components/customers'
    import vue_map from './components/map'
    import tou from '../../../assets/images/tou.png'
    export default {
        name: "medical",
        data() {
            let self = this;
            return {
                id: "",
                status:'',
                loading: false,
                tags: ['辖区事务','会议/活动'],
                activeName: 'information',
                departmentName: 'first',
                teamArray:[],
                cordBool: false,
                agendaBool: false,
                changeBool: false,
                speakBool:false,
                coordinatesBool: false,
                actualBool:false,
                pictureAdd: false,
                AgendaAdd: false,
                estimatesBool: false,
                modelSavePlanPs:false,
                contents:'',
                identity: true,
                labelPosition:'right',
                radio: '1',
                address: '',  //获取的位置
                center: [121.59996, 31.197646],  // 初始中心
                // 点击显示的标记默认的定位
                markers: [{
                    position: [121.59996, 31.197646]
                }],
                zoom:16,
                label:{
                    content:'',
                    offset:[10,12]
                },
                lng: '',
                lat: '',
                nowLng:'',
                nowLat:'',
                loaded: false,
                //  自动定位到当前位置
                plugin: [{
                    timeout: 100, //超过10秒后停止定位，默认：无穷大
                    panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
                    zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
                    pName: 'Geolocation',
                    events: {
                        click(e) {
                            // alert(1)
                        },
                        init(o) {

                            if (self.$route.params.activity_id === undefined){
                                // o 是高德地图定位插件实例
                                o.getCityInfo((status, result) => {

                                    self.address = result.city;
                                    self.lng = result.center[0];
                                    self.lat = result.center[1];
                                    self.center = result.center
                                    self.markers[0].position = [self.lng, self.lat]
                                    self.$nextTick();
                                    // if (result && result.position) {
                                    //     self.address = result.formattedAddress;
                                    //     self.lng = result.position.lng;
                                    //     self.lat = result.position.lat;
                                    //     self.center = [self.lng, self.lat];
                                    //     self.markers[0].position = [self.lng, self.lat]
                                    //     self.loaded = true;
                                    //     self.$nextTick();
                                    // }
                                });
                            } else {
                                self.markers[0].position = self.center
                            }

                            o.getCityInfo((status, result) => {
                                self.nowLng = result.center[0];
                                self.nowLat = result.center[1];
                                self.$nextTick();
                            });

                        }
                    }
                },
                    {
                        pName: 'ToolBar',
                        position:'RB',
                        locate:false,
                        events: {
                            init(instance) {

                            }
                        }
                    }
                ],
                activity_id:'',
                options_getMeetingList:[],
                data:{

                },
                options: [],
                value: [],
                tableData: [],
                events: {
                    click(e) {

                        let lng;
                        let lat;

                        if (self.meetInfo.lng === null ){
                            lng = self.nowLng;
                            lat = self.nowLat;
                            self.center=[lng,lat]
                        }else {
                            lng = e.lnglat.lng;
                            lat = e.lnglat.lat;
                        }
                        self.lng = lng;
                        self.lat = lat;
                        self.meetInfo.lng = lng
                        self.meetInfo.lat = lat

                        self.markers = [{
                            position: [self.lng, self.lat],
                            icon: '',
                            title: '',
                            events: {
                                click(o) {

                                }
                            }
                        }];
                        let geocoder
                        AMap.plugin("AMap.Geocoder",function(){
                            // 这里通过高德 SDK 完成。
                            geocoder = new AMap.Geocoder({
                                radius: 1000,
                                extensions: "all"
                            });
                        })


                        geocoder.getAddress([lng, lat], function (status, result) {
                            if (status === 'complete' && result.info === 'OK') {
                                if (result && result.regeocode) {
                                    self.address = result.regeocode.formattedAddress;    //获取到位置

                                    // self.meetInfo.location_name =
                                    let obj = result.regeocode
                                    let addrObj = result.regeocode.addressComponent
                                    self.meetInfo.location_name = obj.formattedAddress
                                    self.meetInfo.address = addrObj.province + addrObj.district + addrObj.street +
                                        addrObj.township + addrObj.streetNumber
                                    self.$nextTick();
                                }
                            }
                        });
                    }
                },
                searchOption: {
                    citylimit: true
                },
                territoryArray:[],
                meetInfo:{
                    territory_id:"",
                    activity_id: "",
                    activity_date: "",
                    campaign_name: "",
                    location: "",
                    address: "",
                    start_time: "",
                    end_time: "",
                    planned_participants:'',
                    planned_expense: '',
                    comments: '',
                    location_id: '',
                    status: '',
                    created_by: this.$store.getters.getUser.user_id,
                    last_name: this.$store.getters.getUser.alias,
                    key: '',
                    value1: '',
                    location_name: '',
                    postcode: '',
                    telephone: '',
                    website: '',
                    lng: '',
                    lat: '',
                    teamArray: [],
                    productArray: [],
                    expenseArray: [],
                    psArray: [],
                },
                meetInfoCopy:{
                    territory_id:"",
                    activity_id: "",
                    activity_date: "",
                    campaign_name: "",
                    location: "",
                    address: "",
                    start_time: "",
                    end_time: "",
                    planned_participants:'',
                    planned_expense: '',
                    comments: '',
                    location_id: '',
                    status: '',
                    created_by: this.$store.getters.getUser.user_id,
                    last_name: this.$store.getters.getUser.alias,
                    key: '',
                    value1: '',
                    location_name: '',
                    postcode: '',
                    telephone: '',
                    website: '',
                    lng: '',
                    lat: '',
                    teamArray: [],
                    productArray: [],
                    expenseArray: [],
                    psArray: [],
                },
                teamArrayInfo:[],
                options_productArray:[],
                productArrayInfo:[],
                psArray:[],
                agenda:[],
                //预估费用分页
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                //预估费用列表数据
                meetingExpenseList:[],
                //预估费用详情使用的变量
                meetingExpenseModelInfo:{
                    key_id:'',
                    campaign_id:'',
                    category_id:'',
                    category_name : '',
                    amount:'',
                    comments:'',
                    quantity:'',
                },
                meetingExpenseSelect:[],
                //实际参会
                formParticipant:{
                    //实际参会列表
                    concatList:[],
                    audienceList:[],
                    speakerList:[],
                    //实际参会机构列表
                    instutionsList:[],
                    //实际参会机构科室列表
                    instutionsDeptList:[],
                    instutionsHcpList:[],
                    retailStoreList:[],
                    retailStoreClerk:[],
                    distributorList:[],
                    distributorContact:[]
                },
                selectType:'',
                activeDepart:'',
                concatListCopy :[],
                instutionsHcpListCopy:[],
                customersOnOff:false,
                options_perform:[],
                onoffWritePen:true,
                writePenBtnOnOff:true,
                onoffMap:false,
                isShowMap:true,
                onoffMaprefresh:true,
                max:0,
                isInfo : false,
                isIndex:0,

                //权限判断按钮
                onoffTabs:false,        //tabs隐藏
                managerOnOff1:false,    //是否为主管
                submitOnOff:false,      //提交按钮
                completeOnOff:false,    //完成按钮
                deleteOnOff:false,      //删除按钮
                refusedOnOff : false,   //拒绝按钮
                agreedOnOff : false,    //同意按钮
                formOnOff : false,      //会议信息表单禁用
                saveOnOff: false,       //保存按钮
                saveManageOnOff:true,   //控制主管保存 和 代表保存
                meetBarOnOff : false,   //数据加载完成后显示头部签到信息
                sceneUpload:false,//现场照片是否能添加
                agendaUpload:false,//议程照片是否能添加
                isDeletePhoto:true,
                meetInfoStatus : '',
                agendaEditorList:{
                    start_time:'',
                    end_time:'',
                    title:''
                },
                pickerOptions0: {},
                pickerOptions1: {},
                photoItem:{},
                photoArray:[],
                photoItemAgenda:{},
                photoArrayAgenda:[],
                photoIdItem:{},
                photoIdItemAgenda:{},
                photoArrayId:[],
                photoArrayIdAgenda:[],
                category:{},
                categoryAgenda:{},
                uuid:'',
                uuidAgenda:'',
                delPhoto:{},
                dialogSrc:'',
                delPhoto_now:{},
                dialogSrc_now:'',
                dialogImageUrl:'',
                dialogVisible:false,
                dialogVisibleImg:false,
                dialogVisibleImg_now:false,
                class_active:this.$store.getters.getUser.role !== 'staff',
                editOnOff:true,
                ps_height:'',
                clientObj:'',
                user_id: this.$store.getters.getUser.user_id

            }
        },
        components: {
            meetBar,
            pagination,
            customers,
            vue_map,
            // Upload
        },
        updated(){

        },
        filters:{
            componentFliter:function (value) {

                return moment(value).format('YYYY-MM-DD')
            },
            filter_covegr:function (item) {
                if (item.calls == '0'&& item.campaigns == '0'&& item.reference_obj=='HCP'){
                    return '本月尚未覆盖'
                } else {
                    let str =''
                    if (item.calls != '0'&& item.reference_obj=='HCP'){
                        str = '本月已覆盖(医务拜访'
                    }
                    if (item.campaigns != '0'&& item.reference_obj=='HCP'){
                        if (str != ''){
                            str = str + "、科室会"
                        } else {
                            str = str + "本月已覆盖(科室会"
                        }
                    }
                    if (str!=''){
                        str = str+")"
                    }
                    return str
                }
            },
            filterSelectItem:function (item) {
                let str = ''
                if (item.attendant_role === "SPEAKER") {
                    str = str + '[讲者]' + ' '
                }else if (item.attendant_role === "AUDIENCE") {
                    str = str + '[听众]' + ' '
                }
                str += item.reference_name
                if(item.job_title){
                    str+=' '+item.job_title
                }
                str+=" | "
                if(item.dept_name){
                    str+=item.dept_name
                }
                str+=' '+item.department_name
                return str
            },
            timeFormat:function(time){
                return moment(time).format('YYYY年M月D日 HH:mm')
            }
        },
        watch:{
          // 'formParticipant.concatList':{
          //     handler:function (n,o) {
          //         this.judegParticipant(n)
          //     },
          //     deep : true
          // }
            'meetingExpenseModelInfo.amount':{
                handler:function (n,o) {
                    n=parseFloat(n)
                    if (n > this.max){
                        this.$message({
                            type:'error',
                            message:'预估费用合计不能大于计划费用合计'
                        })
                        this.meetingExpenseModelInfo.amount = ''
                    }

                },
                deep:true
            },
            'meetInfo.planned_expense':{
                handler:function (n,o) {
                    this.max = n
                }
            }
        },
        created () {
            if (this.$store.getters.getUser.role === "staff") {
                this.managerOnOff1 = false //代表
            }else {
                this.managerOnOff1 = true //主管
            }
            if (this.managerOnOff1 === true) {
                this.agreedOnOff=false
                this.refusedOnOff=false
                this.submitOnOff=false
                this.deleteOnOff = false
            }else {
                this.agreedOnOff=false
                this.refusedOnOff=false
                this.submitOnOff=false
            }
            if(this.$route.params.type === 'new'){
                this.meetBarOnOff = true
                this.cordBool = true
                this.status = 'NEW'
                this.saveOnOff = true
                if (this.managerOnOff1 === true){
                    this.agreedOnOff=false
                    this.refusedOnOff=false

                } else {
                    this.submitOnOff=true
                }
                this.getTerritory()
            } else if(Object.keys(this.$route.params).length === 0){
                let condition = localStorage.getItem('condition')
                this.activity_id = JSON.parse(condition).activity_id
                this.status = 'INFO'
                this.init();
            } else {
                this.activity_id = this.$route.params.activity_id
                this.status = 'INFO'
                this.init();
            }
            this.clientObj=this.$store.getters.getClient
            this.getManager();
            this.getMeetingList();
            this.getProductList();
            this.getExpenseCategoryList()

        },
        mounted () {
            // document.getElementById('main').scrollTo(0, 0)

            this.$nextTick(()=>{
                let element_height=document.querySelector('#tabs_meetinfg')
                let style =window.getComputedStyle(element_height,null)
                let a = JSON.parse(JSON.stringify(style));
                console.log(a.height)
                this.ps_height=style
                // console.log(this.ps_height)
            })


        },
        methods: {
            getTerritory(){
                var user = this.$store.getters.getUser
                let data ={
                    user_id :user.user_id,
                    tenant_id: user.tenant_id,
                    search: this.queryString,
                    month : moment().format('YYYYMM'),
                    type : true,
                    isAdmin:false,
                    role : user.role
                }
                if (this.class_active){
                    data.type = true
                } else {
                    data.type = false
                }
                if (user.role === 'admin'){
                    data.isAdmin=true
                }

                http.post('/wapi/Conference/getTerritory',data).then(res=>{
                  if (res.success === true){
                      this.territoryArray = res.data
                      if (!this.meetInfo.territory_id){
                          if (this.territoryArray.length === 1){
                            this.meetInfo.territory_id = this.territoryArray[0].territory_id
                          }
                      }
                  }else {

                  }
              })
            },
            dialogVisibles(photoUrl) {
                this.delPhoto = photoUrl
                this.dialogSrc = photoUrl.img
                this.dialogVisibleImg = true
            },
            dialogVisibles_now(photoUrl) {
                this.delPhoto_now = photoUrl
                this.dialogSrc_now = photoUrl.img
                this.dialogVisibleImg_now = true
            },
            clearFiles () {
                this.$refs['uploadFile'].clearFiles();
            },
            clearFilesAgenda () {
                this.$refs['uploadFileAgenda'].clearFiles();
            },
            async init(type){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    // // 上传图片获取图片id
                    this.category = {
                        reference_obj: 'CLIENT',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        username:this.$store.getters.getUser.username,
                        user_id:this.$store.getters.getUser.user_id,
                        event_obj : 'CAMPAIGN',
                        event_id:this.activity_id,
                        category:'PICTURE',
                        data:this.uuid
                    }
                    this.categoryAgenda = {
                        reference_obj: 'CLIENT',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        username:this.$store.getters.getUser.username,
                        user_id:this.$store.getters.getUser.user_id,
                        event_obj : 'CAMPAIGN',
                        event_id:this.activity_id,
                        category:'PICTURE',
                        data:this.uuidAgenda
                    }
                    let user = this.$store.getters.getUser
                    let data={
                        activity_id:this.activity_id,
                        tenant_id : user.tenant_id,
                        user_id : user.user_id,
                    }
                    await http.post('/wapi/Conference/getMeetingInfo',data).then(res=>{
                        if(res.success === true){

                            this.getCheckListById(res.data)
                            this.meetInfoStatus = res.data.status
                            this.data = res.data
                            this.meetInfo = res.data
                            console.log(this.meetInfo)
                            if (this.meetInfo.lng === 0 || this.meetInfo.lat === 0) {
                                this.isShowMap = false
                            }else {
                                this.isShowMap = true
                            }
                            this.teamArray = res.data.teamArray
                            this.psArray = res.data.psArray
                            this.lng = res.data.lng
                            this.lat = res.data.lat
                            this.onoffMap = true
                            this.center=[this.lng,this.lat]
                            this.markers[0].position = [this.lng,this.lat]
                            this.max = this.meetInfo.planned_expense
                            this.productArrayInfo = []
                            for (let i=0;i<this.meetInfo.productArray.length;i++){
                                this.productArrayInfo.push(this.meetInfo.productArray[i].key)
                            }
                            this.teamArrayInfo= []
                            for (let i=0;i<this.meetInfo.teamArray.length;i++){
                                this.teamArrayInfo.push(this.meetInfo.teamArray[i].key)
                            }
                            //判断权限
                            this.judgeAuthority(res.data)
                            loading.close()

                            for (let j=0;j<this.psArray.length;j++){
                                if (this.psArray[j].photo_id) {
                                 this.getHeadPortraitImg(this.psArray[j])
                                }else {
                                    this.psArray[j].src = tou
                                }
                            }
                            if(res.data.isClosed=='T'){
                                this.submitOnOff=false
                                this.deleteOnOff=false
                                this.agreedOnOff=false
                                this.refusedOnOff=false
                                this.saveOnOff=false
                                this.writePenBtnOnOff=false
                                this.saveManageOnOff=false
                                this.saveOnOff=false
                                this.editOnOff=false
                            }
                            const isExecutor = this.teamArray.some(item =>{
                                item.key = user.user_id
                            })
                            this.sceneUpload = isExecutor || res.data.created_by == user.user_id
                            this.agendaUpload = res.data.created_by == user.user_id
                        }
                    })
                    this.getMeetingPhoto()
                    this.getMeetingAgendaPhoto()
                    this.getMeetingAgenda()
                    // this.getMeetingExpense()
                    this.getExpenseCategoryList()
                    this.getTerritory()
                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            //获取签到
            async getCheckListById(obj){
                let data =obj
                data.tenant_id = this.$store.getters.getUser.tenant_id
                data.id =obj.activity_id
                data.user_id = obj.created_by
                data.date = moment(obj.activity_date).format('YYYY-MM-DD')
                await http.post('/wapi/Conference/getCheckListById',data).then(res=>{
                   obj.array=res.data
                })
                this.data = obj
                this.meetBarOnOff = true
            },
            //判断权限
            judgeAuthority(obj){


                let user = this.$store.getters.getUser

                if (this.managerOnOff1 === true){    //是主管
                    if (obj.status !== 'APPROVED'){
                        this.onoffTabs = false
                    }

                    if (user.user_id === obj.created_by){   //是自己创建
                        this.saveOnOff = true
                        this.deleteOnOff = true
                        if (obj.status === 'SUBMITTED' || obj.status === 'APPROVED') {  //  已提交和已审批 隐藏保存提交按钮
                            this.agreedOnOff=false
                            this.refusedOnOff=false
                            this.saveOnOff = false
                            this.submitOnOff = false
                            this.deleteOnOff = false
                            if (obj.status === 'APPROVED')  //已批准 并且是自己创建显示完成按钮
                            {
                                this.onoffTabs = true
                                this.completeOnOff = true
                                this.saveOnOff = true
                            }
                        }else {                             //  未提交 显示保存提交和提交按钮
                            this.agreedOnOff=false
                            this.refusedOnOff=false
                            this.saveOnOff = true
                            this.submitOnOff = true
                            this.deleteOnOff = true
                        }

                        // if (obj.status === 'APPROVED' || obj.status === 'DENIED') {
                        //     this.agreedOnOff = false
                        //     this.refusedOnOff=false
                        //
                        // }else {
                        //     // this.agreedOnOff=true
                        //     // this.refusedOnOff=true
                        //     this.saveOnOff = true
                        // }
                    }else {   //不是自己创建
                        if (obj.status === 'SUBMITTED') {  //已提交
                            this.refusedOnOff = true
                            this.agreedOnOff = true
                            this.saveOnOff = false
                        }else if (obj.status === 'APPROVED') {  //已确认
                            this.onoffTabs = true
                            this.refusedOnOff = false
                            this.agreedOnOff = false
                            this.saveManageOnOff = false
                            this.saveOnOff = true
                            this.completeOnOff = false
                        }else if (obj.status === 'DENIED') {  //已拒绝
                            this.saveOnOff = false
                            this.agreedOnOff = false
                            this.refusedOnOff = false
                        }
                    }

                }else {  //不是主管
                    if (obj.created_by !== user.user_id){       //不是自己创建
                        this.deleteOnOff = false
                        this.saveOnOff = true
                        this.saveManageOnOff = false
                        this.submitOnOff = false
                        if (obj.status === 'SUBMITTED') {
                            this.saveOnOff = false
                        }else if (obj.status === 'APPROVED') {
                            this.onoffTabs = true
                            this.refusedOnOff = false
                            this.agreedOnOff = false
                            this.saveManageOnOff = false
                            this.saveOnOff = true
                            this.completeOnOff = false
                        }
                    }else {  //是自己创建
                        if (obj.status === 'SUBMITTED') {
                            this.saveOnOff = false
                            this.submitOnOff = false
                            this.deleteOnOff = false
                        }else if (obj.status === 'APPROVED') {
                            this.saveOnOff = true
                            this.onoffTabs = true
                            this.deleteOnOff = false
                            this.completeOnOff = true
                        }else {
                            this.saveOnOff = true
                            this.submitOnOff = true
                            this.deleteOnOff = true
                            this.completeOnOff = false
                        }
                        if (obj.status !== 'APPROVED'){
                            this.onoffTabs = false
                        }
                    }

                }
                //已完成所有人都无法修改
                if (obj.status === 'APPROVED' && obj.completed === 'T'){
                    this.saveOnOff = false
                    this.saveManageOnOff = false
                    this.completeOnOff = false
                    this.agreedOnOff = false
                    this.refusedOnOff = false
                    this.deleteOnOff = false
                }

                if (obj.completed === 'T'){
                    this.writePenBtnOnOff = false
                    this.isDeletePhoto = false
                }
                // if (obj.created_by === user.user_id) {//自己创建的
                //     this.agreedOnOff=false
                //     this.refusedOnOff=false
                //     this.submitOnOff=true
                //     this.saveOnOff = true
                //     //处于审批状态或是审批通过无法修改
                //     if (obj.status === 'SUBMITTED' || obj.status === "APPROVED"){
                //         this.saveOnOff = false
                //         if (obj.status === "APPROVED") {//审批通过后可以修改，修改完需得提交
                //             //可以修改，可以提交
                //             this.submitOnOff = false
                //
                //         }else {
                //             //可以修改，可以提交
                //             this.submitOnOff = false
                //             // this.saveOnOff = true
                //             //如果是管理者不能提交
                //             if (user.role !== 'manager'){
                //                 this.submitOnOff = false
                //             }
                //         }
                //     }
                // }else {//不是自己创建的，看是否有审批权限，否则隐藏
                //     if (user.role === 'manager') {//有权限审批
                //         this.agreedOnOff = true
                //         this.refusedOnOff = true
                //         if (obj.status === 'SUBMITTED') {//已提交，显示同意或拒绝
                //             // this.agreedOnOff = false
                //             // this.refusedOnOff = false
                //         }
                //     }
                // }

                // if (obj.status === 'APPROVED'){
                //     this.onoffTabs = true
                // }else {
                //     this.onoffTabs = false
                // }
            },
            chooseTimeRange0(t){

                let dateA = new Date(t);
                let dateB = new Date();

                let timeOnoff = (dateA.setHours(0, 0, 0, 0) == dateB.setHours(0, 0, 0, 0))

                // if (timeOnoff){
                //     this.agendaEditorList.start_time = ''
                // }
            },
            chooseTimeRange2(t){

                let time1 = moment(t).valueOf()
                let time2 = moment(this.agendaEditorList.start_time).valueOf()
                let dateA = new Date(t);
                let dateB = new Date(this.agendaEditorList.start_time);


                if (time1<=time2){
                    this.$message({
                        type:"warning",
                        message:"结束时间应晚于开始时间"
                    })
                    this.agendaEditorList.end_time = ''
                }
            },
            // 执行人
            async getManager(){
                try {
                    let data={
                        user_id : this.$store.getters.getUser.user_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/Calendar/getManger',data).then(res=>{
                        this.options_perform = res.data

                    })
                } catch (e) {

                }
            },
            chooseTimeRange1(t){

                let time1 = moment(t).valueOf()
                let time2 = moment(this.meetInfo.start_time).valueOf()

                if (time1<=time2){

                    this.$message({
                        type:"warning",
                        message:"结束时间应晚于开始时间"
                    })
                    this.meetInfo.end_time = ''
                }
            },
            // 会议列表
            async getMeetingList(){
                try {
                    let data={
                        user_id : this.$store.getters.getUser.user_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/WeekPlan/getMeetingList',data).then(res=>{
                        this.options_getMeetingList = res.data

                    })
                } catch (e) {

                }
            },
            async getProductList(){
                try {
                    let data={
                        user_id : this.$store.getters.getUser.user_id,
                        tenant_id : this.$store.getters.getUser.tenant_id,
                    }
                    await http.post('/wapi/Conference/getProductList',data).then(res=>{
                     if (res.success === true){
                         this.options_productArray = res.data

                     }
                    })
                }catch (e) {

                }
            },
            // 写一笔
            async savePlanPs(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        type:'MEETING',
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        id:this.activity_id,
                        user_id : this.$store.getters.getUser.user_id,
                        contents:{
                            comments:this.contents,
                            photos:[]
                        }
                    }
                    await http.post('/wapi/Evection/savePlanPs',data).then(res=>{
                        if (res.success === true){
                            this.init()
                            this.$message({
                                type:'success',
                                message:'保存成功'
                            })
                            this.modelSavePlanPs= false
                            this.contents = ''
                            loading.close()
                        }

                    })
                } catch (e) {
                    loading.close()
                }

            },
            // 获取会议议程列表
            async getMeetingAgenda(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id : this.$store.getters.getUser.user_id,
                        campaign_id:this.activity_id,
                    }
                    await http.post('/wapi/Conference/getMeetingAgenda',data).then(res=>{
                        if(res.success == true){
                            this.judeg(res.data)

                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            judeg(arr){
                let array = arr
                console.log(arr,66)
                array.forEach((item,i)=>{
                    // item.activity_date= moment(item.activity_date).format('YYYY年MM月DD日')
                    var str = item.start_time;
                    var str1 = item.end_time;
                    item.year = str.split('')[0]+str.split('')[1]+str.split('')[2]+str.split('')[3];
                    item.month = parseInt(str.split('')[5]+str.split('')[6]);
                    item.day = parseInt(str.split('')[8]+str.split('')[9]);
                    item.start = str.split('')[11]+str.split('')[12]+str.split('')[13]+str.split('')[14]+str.split('')[15];
                    item.end = str1.split('')[11]+str1.split('')[12]+str1.split('')[13]+str1.split('')[14]+str1.split('')[15];
                })
                this.agenda = array
            },
            agendaEditor(item){
                this.agendaEditorList =JSON.parse(JSON.stringify(item));
            },

            closeAgendaBool(){
                this.agendaBool = false
                this.$refs['formlistAgenda'].resetFields();
            },
            inputSaveMeetingAgenda(){
                this.$refs["formlistAgenda"].validate(valid=>{
                    if(!valid){
                        return false
                    }else {
                        this.saveMeetingAgenda()
                    }
                })
            },

            // 保存会议议程
            async saveMeetingAgenda(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data = {
                        key_id:this.agendaEditorList.key_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id : this.$store.getters.getUser.user_id,
                        campaign_id:this.activity_id,
                        title:this.agendaEditorList.title,
                        speaker:this.agendaEditorList.speaker,
                        start_time:this.agendaEditorList.start_time,
                        end_time:this.agendaEditorList.end_time,
                    }

                    if (!data.start_time) {
                        this.$message({
                            type:'error',
                            message:'请选择开始时间'
                        })
                        loading.close()
                        return false
                    }
                    if (!data.end_time) {
                        this.$message({
                            type:'error',
                            message:'请选择结束时间'
                        })
                        loading.close()
                        return false
                    }
                    await http.post('/wapi/Conference/saveMeetingAgenda',data).then(res=>{
                        if(res.success == true){
                            this.init()
                            this.$message({
                                type:'success',
                                message:'保存成功'
                            })
                            this.agendaBool = false
                        }
                    })

                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },

            // 添加会议议程
            addAgenda(){
                this.agendaEditorList = [];
            },

            openSavePlanModel(){
                this.modelSavePlanPs= true
            },
            identityClick(){
                this.identity = !this.identity
            },
            pictureAddClick(){
                this.pictureAdd = true;
            },
            pictureAddAgendaClick(){
                this.AgendaAdd = true;
            },
            onSearchResult(pois) {

                let obj = pois[0]

                this.center = [obj.lng, obj.lat];
                this.markers[0].position = this.center
                this.meetInfo.lng = obj.lng
                this.meetInfo.lat = obj.lat
                this.meetInfo.address = obj.address
                this.meetInfo.location_name = obj.name

                // console.log(pois)
                // let latSum = 0;
                // let lngSum = 0;
                // if (pois.length > 0) {
                //     pois.forEach(poi => {
                //         let {lng, lat} = poi;
                //         lngSum += lng;
                //         latSum += lat;
                //         this.markers.push([poi.lng, poi.lat]);
                //     });
                //     let center = {
                //         lng: lngSum / pois.length,
                //         lat: latSum / pois.length
                //     };
                //     this.center = [center.lng, center.lat];
                //     console.log(this.center)
                // }
            },
            //选项卡点击
            handleClickList(type){
                this.onoffWritePen = false
                this.customersOnOff = false
                if (type.name === 'estimates'){
                    // this.getMeetingExpense()
                    // this.getExpenseCategoryList()
                    this.onoffWritePen = false
                }else if (type.name === 'participation') {
                    this.getMeetingParticipant()
                    this.onoffWritePen = false
                }else if (type.name === "customers"){
                    this.customersOnOff = true
                    this.onoffWritePen = false
                }else if (type.name ===  "photos") {
                    this.onoffWritePen = false
                }else if (type.name === "information") {
                    if (this.status === 'INFO'){
                        this.onoffWritePen = true
                    }

                }else if (type.name === "agenda"){
                    if (this.status === 'INFO') {
                        this.onoffWritePen = true
                    }

                }
                if (this.meetInfo.completed === 'T'){
                    this.onoffWritePen = false
                }
            },

            // 获取照片id
            async getMeetingPhoto(){

                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    //判断当前用户是否在执行人中
                    const isF = this.teamArray.some(item=>{
                        item.key == user.user_id
                    })
                    let data={
                        tenant_id:user.tenant_id,
                        user_id : user.user_id,
                        role : user.role,
                        campaign_id:this.activity_id,
                        isF:!isF
                    }
                    // if (this.data.created_by === user.user_id) {
                    //     data.isF = true
                    // }else {
                    //     data.isF = false
                    // }

                    await http.post('/wapi/Conference/getMeetingPhoto',data).then(res=>{

                        if(res.success == true){

                            this.photoArray=[]
                            for(var i=0;i<res.data.length;i++){
                                this.getImgUrl(res.data[i].photo_id,res.data[i].created_date,res.data[i].created_by)
                            }
                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            // 获取会议议程照片id
            async getMeetingAgendaPhoto(){

                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id:user.tenant_id,
                        user_id : user.user_id,
                        campaign_id:this.activity_id,
                        role : user.role
                    }
                    // if (this.data.created_by === user.user_id) {
                    //     data.isF = true
                    // }else {
                    //     data.isF = false
                    // }

                    await http.post('/wapi/Conference/getMeetingAgendaPhoto',data).then(res=>{

                        if(res.success == true){
                            this.photoArrayAgenda =[]
                            for(var i=0;i<res.data.length;i++){
                                this.getImgUrlAgenda(res.data[i].photo_id,res.data[i].created_date)
                            }
                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            // 通过图片id获取图片
            async getImgUrl(id,date,created_by='') {
                try {
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                }

                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data
                    if (array.length > 0) {
                        this.photoItem.photoUrl = array[0].thu_url
                        let photoObj = {
                            id:id,
                            img:array[0].thu_url,
                            date:date,
                            created_by:created_by
                        }
                        this.photoArray.push(photoObj)
                        this.sortKey(this.photoArray, "date")
                        this.$forceUpdate()
                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            //会议议程 通过图片id获取图片
            async getImgUrlAgenda(id,date) {
                try {
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data
                    if (array.length > 0) {
                        this.photoItemAgenda.photoUrl = array[0].thu_url
                        let photoObj = {
                            id:id,
                            img:array[0].thu_url,
                            date:date
                        }
                        this.photoArrayAgenda.push(photoObj)
                        this.sortKey(this.photoArrayAgenda, "date")
                        this.$forceUpdate()
                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            // 获取图片id
            async getHeadPortraitImg(obj) {
                try {
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: obj.photo_id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data


                    if (array.length > 0) {
                        obj.src = array[0].thu_url
                        this.$forceUpdate()
                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            getUuid() {
                var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                this.uuid = uuid

            },
            getUuidAgenda() {
                var s = [];
                var hexDigits = "0123456789abcdef";

                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                this.uuidAgenda = uuid

            },


            getPhotoId(res,file,fileList){

                this.photoIdItem.photo_id = res.data.s3filename
                this.photoArrayId.push(this.photoIdItem.photo_id)


                // this.$refs.uploadFile.submit()
                this.saveMeetingPhoto()
            },
            getPhotoIdAgenda(res,file,fileList){

                this.photoIdItemAgenda.photo_id = res.data.s3filename
                this.photoArrayIdAgenda.push(this.photoIdItemAgenda.photo_id)


                // this.$refs.uploadFile.submit()
                this.saveMeetingAgendaPhoto()
            },
            addDialogClose(){
                // this.$refs.ruleForm.resetFields();
                // this.$refs.upload.clearFiles();

            },

            beforeUpload(file) {
                if(/\.(jpg|png)$/.test(file.name)) {
                    this.$refs['uploadFile'].submit();

                }else{
                    this.$message({
                        type:'error',
                        message:'图片格式只能为jpg/png'
                    })
                }

            },
            beforeUploadAgenda(file) {
                if(/\.(jpg|png)$/.test(file.name)) {
                    this.$refs['uploadFileAgenda'].submit();
                }else{
                    this.$message({
                        type:'error',
                        message:'图片格式只能为jpg/png'
                    })
                }

            },
            // 保存图片
            async saveMeetingPhoto(){

                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{

                    for(var i=0;i<this.photoArrayId.length;i++){
                        let data={
                            tenant_id:this.$store.getters.getUser.tenant_id,
                            user_id : this.$store.getters.getUser.user_id,
                            campaign_id:this.activity_id,
                            photo_id:this.photoArrayId[i],
                            sort:Number(this.photoArray.length)+1+i
                        }


                        await http.post('/wapi/Conference/saveMeetingPhoto',data).then(res=>{
                            // console.log(res)
                            if(res.success === true && res.addimg === true){
                                this.getImgUrl(this.photoArrayId[i])
                                this.$message({
                                    type:'success',
                                    message:'保存成功'
                                })
                                this.photoArrayId = []
                                this.clearFiles()
                                loading.close()
                            }else if (res.success === true && res.addimg === false) {
                                this.photoArrayId = []
                                this.$message({
                                    type:'error',
                                    message:res.message
                                })
                                loading.close()
                            }
                        })
                    }
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            //保存会议议程图片
           async saveMeetingAgendaPhoto(){

               let loading = this.$loading({
                   lock: true,
                   text: '拼命加载中',
                   spinner: 'el-icon-loading',
                   background: 'rgba(0, 0, 0, 0.7)'
               });
               try{

                   for(var i=0;i<this.photoArrayIdAgenda.length;i++){
                       let data={
                           tenant_id:this.$store.getters.getUser.tenant_id,
                           user_id : this.$store.getters.getUser.user_id,
                           campaign_id:this.activity_id,
                           photo_id:this.photoArrayIdAgenda[i],
                           sort:Number(this.photoArrayIdAgenda.length)+1+i
                       }

                       await http.post('/wapi/Conference/saveMeetingAgendaPhoto',data).then(res=>{
                           // console.log(res)

                           if(res.success === true && res.addimg === true){
                               this.getImgUrlAgenda(this.photoArrayIdAgenda[i])
                               this.$message({
                                   type:'success',
                                   message:'保存成功'
                               })
                               this.photoArrayIdAgenda = []
                               this.clearFilesAgenda()
                               loading.close()
                           }else if (res.success === true && res.addimg === false){
                               this.photoArrayIdAgenda = []
                               this.$message({
                                   type:'error',
                                   message:res.message
                               })
                               loading.close()
                           }
                       })
                   }

               }catch (e) {
                   loading.close()
                   return e
               }
           },

            // //获取费用列表
            // async getMeetingExpense(){
            //    let loading = this.$loading({
            //        lock: true,
            //        text: '拼命加载中',
            //        spinner: 'el-icon-loading',
            //        background: 'rgba(0, 0, 0, 0.7)'
            //    });
            //     try {
            //         let user = this.$store.getters.getUser
            //         let data = {
            //             tenant_id : user.tenant_id,
            //             limit: this.page.size,
            //             offset: this.page.current - 1,
            //             campaign_id:this.$route.params.activity_id,
            //         }
            //         await http.post('/wapi/Conference/getMeetingExpense',data).then(res=>{
            //             if (res.success === true){
            //                 console.log(res.data)
            //                 this.meetingExpenseList = res.data.array
            //                 this.page.total = res.data.arrayCount
            //                loading.close()
            //             }
            //         })
            //         loading.close()
            //     }catch (e) {
            //         loading.close()
            //     }
            // },
            //获取费用类别
            async getExpenseCategoryList(){
                try {
                    let data={
                        tenant_id : this.$store.getters.getUser.tenant_id
                    }
                    await http.post('/wapi/Conference/getExpenseCategoryList',data).then(res=>{
                        if (res.success === true){
                            this.meetingExpenseSelect = res.data

                        }
                    })
                }catch (e) {

                }
            },
            closeExpense(){
                this.estimatesBool = false
                this.$refs['formlistExpense'].resetFields();
            },
            //保存费用明细
            inputSaveMeetingExpense(){
                this.$refs["formlistExpense"].validate(valid=>{
                    if(!valid){
                        return false
                    }else {
                        this.saveMeetingExpense()
                    }
                })
            },


            async saveMeetingExpense(){
                try {

                    if (this.isInfo === true){
                        for (let j=0;j<this.meetingExpenseSelect.length;j++){
                            if (this.meetingExpenseSelect[j].key === this.meetingExpenseModelInfo.category_id  ) {
                                this.meetingExpenseModelInfo.category_name = this.meetingExpenseSelect[j].value1
                            }
                        }

                            if (this.meetInfo.expenseArray[this.isIndex].key_id === this.meetingExpenseModelInfo.key_id) {
                                this.meetInfo.expenseArray[this.isIndex].campaign_id = this.meetingExpenseModelInfo.campaign_id
                                this.meetInfo.expenseArray[this.isIndex].category_id = this.meetingExpenseModelInfo.category_id
                                this.meetInfo.expenseArray[this.isIndex].category_name = this.meetingExpenseModelInfo.category_name
                                this.meetInfo.expenseArray[this.isIndex].amount = this.meetingExpenseModelInfo.amount
                                this.meetInfo.expenseArray[this.isIndex].comments = this.meetingExpenseModelInfo.comments
                                this.meetInfo.expenseArray[this.isIndex].quantity = this.meetingExpenseModelInfo.quantity
                            }

                    } else {
                        for (let j=0;j<this.meetingExpenseSelect.length;j++){
                            if (this.meetingExpenseSelect[j].key === this.meetingExpenseModelInfo.category_id  ) {
                                this.meetingExpenseModelInfo.category_name = this.meetingExpenseSelect[j].value1
                            }
                        }
                        this.meetInfo.expenseArray.push(this.meetingExpenseModelInfo)
                    }
                    this.estimatesBool = false
                    this.$forceUpdate()
                    // let data= this.meetingExpenseModelInfo
                    // data.tenant_id = this.$store.getters.getUser.tenant_id
                    // await http.post('/wapi/Conference/saveMeetingExpense',data).then(res=>{
                    //     if (res.success === true){
                    //         this.estimatesBool = false
                    //         this.getMeetingExpense()
                    //     }
                    // })
                }catch (e) {

                }
            },
            //预估费用详情弹窗
            handleExportInfo(index,obj){
                this.isIndex = index
                this.estimatesBool = true
                if (obj !== undefined){
                    this.meetingExpenseModelInfo = JSON.parse(JSON.stringify(obj))
                    this.isInfo = true
                } else {
                    this.isInfo = false
                    this.meetingExpenseModelInfo = {
                        key_id:'',
                        campaign_id:this.activity_id,
                        category_id:'',
                        category_name : '',
                        amount:'',
                        comments:'',
                        quantity:'',
                    }
                }

            },
            handleDetail(index,obj){
              this.meetInfo.expenseArray.splice(index,1)
            },
            checkType(type){
                this.selectType=type
                if(type=='INSTITUTION'){
                    this.getInstutionsList()
                }else if(type=='RETAILSTORE'){
                    this.getRetailstoreList()
                }else if(type=='DISTRIBUTOR'){
                    this.getDistributorList()
                }
            },
            //获取会议参与者
           async getMeetingParticipant(){
               let loading = this.$loading({
                   lock: true,
                   text: '拼命加载中',
                   spinner: 'el-icon-loading',
                   background: 'rgba(0, 0, 0, 0.7)'
               });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id : user.tenant_id,
                        campaign_id:this.activity_id,
                        invited : 'F',
                        attendant:'T',
                        user_id :user.user_id,
                        role: user.role
                    }
                    if (this.data.created_by === user.user_id){
                        data.isF = true
                    } else {
                        data.isF = false
                    }

                    await http.post('/wapi/Conference/getMeetingParticipant',data).then(res=>{
                        if (res.success === true){

                            let arr = res.data
                            this.judegParticipant(arr)

                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            //对会议参与者数据进行处理
            judegParticipant(arr){
                let array = arr
                let audience = []
                let speaker = []
                for (let i=0;i<array.length;i++){
                    if (array[i].attendant_role === 'SPEAKER'){
                        speaker.push(array[i])
                    } else if (array[i].attendant_role === 'AUDIENCE'){
                        audience.push(array[i])
                    }
                }
                this.formParticipant.audienceList = audience
                this.formParticipant.speakerList = speaker
                this.formParticipant.concatList = array
                this.concatListCopy = JSON.parse(JSON.stringify(array))


            },
            //获取机构
            async getInstutionsList(){
                try {
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id: user.tenant_id,
                        user_id : user.user_id,
                        owner_id: this.$store.getters.getUser.user_id,
                        city_id : [],
                        grade_array: [],
                    }
                    await http.post('/wapi/WeekPlan/getInstutionsList',data).then(res=>{
                        if (res.success === true){
                            let array1 = res.data.array
                            let array2 = this.concatListCopy
                            for (let i=0;i<array1.length;i++){
                                array1[i].select = false
                                array1[i].selectPeople_num = 0
                                for (let j=0;j<array2.length;j++){
                                    if (array1[i].institution_id === array2[j].institution_id){
                                        array1[i].selectPeople_num +=1
                                    }
                                }
                            }
                            this.formParticipant.instutionsList = res.data.array
                            array1[0].select = true
                            this.getDeptList(this.formParticipant.instutionsList[0])
                        }

                    })
                }catch (e) {
                }
            },
           //获取科室
           async getDeptList(item){
                try {
                    if(item.select==false){
                        for(let i=0;i<this.formParticipant.instutionsList.length;i++){
                            let obj=this.formParticipant.instutionsList[i]
                            obj.select=false
                        }
                        item.select=true
                    }
                    let data={
                        tenant_id : this.$store.getters.getUser.tenant_id,
                        institution_id: item.institution_id
                    }
                    this.formParticipant.instutionsHcpList = []
                    await http.post('/wapi/Conference/getDeptList',data).then(res=>{
                        if (res.success === true){
                            this.formParticipant.instutionsDeptList = res.data
                            this.activeDepart = this.formParticipant.instutionsDeptList[0].dept_id
                           this.getInstutionsHcpList(item.institution_id,this.formParticipant.instutionsDeptList[0].dept_id)
                        }
                    })
                }catch (e) {

                }
            },
            //实际参会选项卡点击
            handleDepart(type,event){
                let institution_id=''
                for (let i = 0;i<this.formParticipant.instutionsDeptList.length;i++) {
                    if (type.name === this.formParticipant.instutionsDeptList[i].dept_id) {
                        institution_id = this.formParticipant.instutionsDeptList[i].institution_id
                        break
                    }
                }
                this.formParticipant.instutionsHcpList = []
                this.getInstutionsHcpList(institution_id,type.name)
            },
            //获取医生
            async getInstutionsHcpList(institution_id,dept_id){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id:user.tenant_id,
                        institution_id:institution_id,
                        city_id: [],
                        segment_array:[],
                        dept_id:dept_id
                    }
                    await http.post('/wapi/Conference/getInstutionsHcpList',data).then(res=>{
                        if (res.success === true){

                            let array1 = res.data.array
                            let array2 = this.concatListCopy
                            for (let i =0;i<array1.length;i++){

                                // array1[i].department_name=array1[i].institution_name
                                array1[i].onoff = ''
                                for (let j=0;j<array2.length;j++){
                                    if (array1[i].reference_id === array2[j].reference_id){
                                        if (array2[j].invited_role === "SPEAKER") {
                                            array1[i].onoff = "SPEAKER"
                                            break
                                        }else if (array2[j].invited_role === 'AUDIENCE') {
                                            array1[i].onoff = "AUDIENCE"
                                            break
                                        }
                                    }
                                }
                            }
                            this.formParticipant.instutionsHcpList = array1

                        }

                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            //更改颜色
            colorFun(item){
                if (item.calls == '0' && item.campaigns == "0"){
                    return '#ED3B3F'
                } else {
                    return '#4A90E2'
                }
            },
            //选中hcp人员
            DepartClickHcp(obj,type){

                let splictFunction =  (obj)=>{
                    for (let i=0;i<this.concatListCopy.length;){
                        if (obj.reference_id === this.concatListCopy[i].reference_id ){
                            this.concatListCopy.splice(i,1)
                        } else {
                            i++
                        }
                    }
                }
                let select_numFunction = ()=>{
                    let array1=[]
                    let array2 = this.concatListCopy
                    if(this.selectType=='INSTITUTION'){
                        array1 = this.formParticipant.instutionsList
                        for (let i=0;i<array1.length;i++){
                            array1[i].selectPeople_num = 0
                            for (let j=0;j<array2.length;j++){
                                if (array1[i].institution_id === array2[j].department_id){
                                    array1[i].selectPeople_num +=1
                                }
                            }
                        }
                    }else if(this.selectType=='RETAILSTORE'){
                        array1 = this.formParticipant.retailStoreList
                        for (let i=0;i<array1.length;i++){
                            array1[i].selectPeople_num = 0
                            for (let j=0;j<array2.length;j++){
                                if (array1[i].store_id === array2[j].department_id){
                                    array1[i].selectPeople_num +=1
                                }
                            }
                        }

                    }else if(this.selectType=='DISTRIBUTOR'){
                        array1 = this.formParticipant.distributorList
                        for (let i=0;i<array1.length;i++){
                            array1[i].selectPeople_num = 0
                            for (let j=0;j<array2.length;j++){
                                if (array1[i].distributor_id === array2[j].department_id){
                                    array1[i].selectPeople_num +=1
                                }
                            }
                        }
                    }

                }
                if (type === 'uncheck1'){

                    obj.onoff = 'SPEAKER'
                    let item=obj
                    item.attendant_role = obj.onoff
                    splictFunction(obj)
                    this.concatListCopy.push(item)
                    console.log(this.concatListCopy)
                    select_numFunction()
                }else if (type === 'uncheck2') {
                    obj.onoff = 'AUDIENCE'
                    let item=obj
                    item.attendant_role = obj.onoff
                    splictFunction(obj)
                    this.concatListCopy.push(item)
                    console.log(this.concatListCopy)
                    select_numFunction()
                }else if (type === 'spcheck') {
                    obj.onoff = ''
                    splictFunction(obj)
                    select_numFunction()
                }else if (type === 'aucheck') {
                    obj.onoff = ''
                    splictFunction(obj)
                    select_numFunction()
                }

            },
            //添加讲者/听众
            addactualBoolModel(){
                this.actualBool = true
                // this.selectType='INSTITUTION'
                // setTimeout(() => {
                //     this.getInstutionsList()
                // }, 200)
                // this.instutionsHcpListCopy = JSON.parse(JSON.stringify(this.formParticipant.instutionsHcpList))
                if(this.clientObj.showInstitution){
                    this.selectType='INSTITUTION'
                    setTimeout(() => {
                        this.getInstutionsList()
                    }, 200)
                    this.instutionsHcpListCopy = JSON.parse(JSON.stringify(this.formParticipant.instutionsHcpList))
                }else if(!this.clientObj.showInstitution && this.clientObj.showStore){
                    this.selectType='RETAILSTORE'
                    setTimeout(() => {
                        this.getRetailstoreList()
                    }, 200)
                }else if(!this.clientObj.showInstitution && !this.clientObj.showStore && this.clientObj.showDistributor){
                    this.selectType='DISTRIBUTOR'
                    setTimeout(() => {
                        this.getDistributorList()
                    }, 200)
                }
            },
            //关闭实际参会模态框
            closeActualBool(){
                this.concatListCopy = JSON.parse(JSON.stringify(this.formParticipant.concatList))
                this.formParticipant.instutionsHcpList = JSON.parse(JSON.stringify(this.instutionsHcpListCopy))

                let array1 = this.formParticipant.instutionsList
                let array2 = this.concatListCopy
                for (let i=0;i<array1.length;i++){
                    array1[i].selectPeople_num = 0
                    for (let j=0;j<array2.length;j++){
                        if (array1[i].institution_id === array2[j].institution_id){
                            array1[i].selectPeople_num +=1
                        }
                    }
                }
                this.actualBool = false
             },
            //保存实际参会
           async saveActualBool(){
                this.formParticipant.concatList = JSON.parse(JSON.stringify(this.concatListCopy))
                for (let i =0;i<this.formParticipant.concatList.length;i++){
                    this.formParticipant.concatList[i].invited_role = ''
                    this.formParticipant.concatList[i].invited = 'F'
                    this.formParticipant.concatList[i].attendant = 'T'
                }
                let user = this.$store.getters.getUser
                let data={
                    tenant_id : user.tenant_id,
                    etms_activity_campaign_participant:this.formParticipant.concatList,
                    campaign_id:this.activity_id,
                    attendant : 'T',
                    invited : 'F',
                    invited_role : '',
                    user_id :user.user_id
                }
                await http.post('/wapi/Conference/saveMeetingParticipant',data).then(res=>{
                    if (res.success === true){
                        this.getMeetingParticipant()
                        this.actualBool = false
                        this.$message({
                            type:'success',
                            message:'保存成功'
                        })
                    }
                })

            },
            async getRetailstoreList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id: user.tenant_id,
                        user_id : user.user_id,
                        owner_id: this.$store.getters.getUser.user_id,
                        city_id : [],
                        grade_array: [],
                    }
                    await http.post('/wapi/WeekPlan/getRetailstoreList',data).then(res=>{
                        if(res.success==true){
                            this.formParticipant.retailStoreList=res.data.array
                            if(res.data.array.length>0) {
                                let array2 = this.concatListCopy
                                for (let i = 0; i < this.formParticipant.retailStoreList.length; i++) {
                                    let obj = this.formParticipant.retailStoreList[i]
                                    obj.selectPeople_num = 0
                                    obj.select = false
                                    for (let j = 0; j < array2.length; j++) {
                                        if (obj.store_id === array2[j].department_id) {
                                            obj.selectPeople_num += 1
                                        }
                                    }
                                }
                                this.formParticipant.retailStoreList[0].select = true
                                this.getStorePeopleList(this.formParticipant.retailStoreList[0])
                            }else{
                                loading.close()
                            }
                        }
                    })

                }catch(e){

                }
            },
            async getStorePeopleList(item){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    if(item.select==false){
                        for(let i=0;i<this.formParticipant.retailStoreList.length;i++){
                            let obj=this.formParticipant.retailStoreList[i]
                            obj.select=false
                        }
                        item.select=true
                    }
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id:user.tenant_id,
                        retailstore_id:item.store_id,
                    }
                    await http.post('/wapi/Conference/getRetailstoreClerkList',data).then(res=>{
                        if(res.success==true){
                            let array2 = this.concatListCopy
                            for (let i =0;i<res.data.length;i++){
                                res.data[i].department_name=item.store_name
                                res.data[i].reference_obj='CLERK'
                                res.data[i].onoff = ''
                                for (let j=0;j<array2.length;j++){
                                    if (res.data[i].reference_id === array2[j].reference_id){
                                        if (array2[j].invited_role === "SPEAKER") {
                                            res.data[i].onoff = "SPEAKER"
                                            break
                                        }else if (array2[j].invited_role === 'AUDIENCE') {
                                            res.data[i].onoff = "AUDIENCE"
                                            break
                                        }
                                    }
                                }
                            }
                            this.formParticipant.retailStoreClerk = res.data
                        }
                        loading.close()
                    })
                }catch (e) {

                }
            },
            async getDistributorList(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id: user.tenant_id,
                        user_id : user.user_id,
                        owner_id: this.$store.getters.getUser.user_id,
                        city_id : [],
                        grade_array: [],
                    }
                    await http.post('/wapi/Business/getDistributorList',data).then(res=>{
                        if(res.success==true){
                            this.formParticipant.distributorList=res.data.array
                            if(res.data.array.length>0){
                                let array2 = this.concatListCopy
                                for(let i=0;i<this.formParticipant.distributorList.length;i++){
                                    let obj=this.formParticipant.distributorList[i]
                                    obj.selectPeople_num=0
                                    obj.select=false
                                    for (let j=0;j<array2.length;j++){
                                        if (obj.distributor_id === array2[j].department_id){
                                            obj.selectPeople_num +=1
                                        }
                                    }
                                }
                                this.formParticipant.distributorList[0].select = true
                                this.getDistributorContactList(this.formParticipant.distributorList[0])
                            }else{
                                loading.close()
                            }

                        }
                    })

                }catch(e){

                }
            },
            async getDistributorContactList(item){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    if(item.select==false){
                        for(let i=0;i<this.formParticipant.distributorList.length;i++){
                            let obj=this.formParticipant.distributorList[i]
                            obj.select=false
                        }
                        item.select=true
                    }
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id:user.tenant_id,
                        distributor_id:item.distributor_id,
                    }
                    await http.post('/wapi/Conference/getDistributorContactList',data).then(res=>{
                        if(res.success==true){
                            for (let i =0;i<res.data.length;i++){
                                res.data[i].department_name=item.distributor_name
                                res.data[i].reference_obj='CONTACT'
                                let array2 = this.concatListCopy
                                res.data[i].onoff = ''
                                for (let j=0;j<array2.length;j++){
                                    if (res.data[i].reference_id === array2[j].reference_id){
                                        if (array2[j].invited_role === "SPEAKER") {
                                            res.data[i].onoff = "SPEAKER"
                                            break
                                        }else if (array2[j].invited_role === 'AUDIENCE') {
                                            res.data[i].onoff = "AUDIENCE"
                                            break
                                        }
                                    }
                                }
                            }
                            this.formParticipant.distributorContact = res.data
                        }
                        loading.close()
                    })
                }catch (e) {

                }
            },

            openUpdatecord(){
                this.meetInfoCopy = JSON.parse(JSON.stringify(this.meetInfo));
                this.center=[this.meetInfo.lng,this.meetInfo.lat]

                this.cordBool = true
            },

            changePicker(e){

                let startTime = moment(e).format()
                let endTime = moment(this.meetInfo.end_time).format()
                if (startTime >= endTime) {
                    this.meetInfo.end_time = ''
                }


            },
            inputUpdateMeetingInfo(){
                this.$refs["formlist"].validate(valid=>{
                    if(!valid){
                        return false
                    }else {
                       this.updateMeetingInfo()
                    }
                })
            },
           async updateMeetingInfo(){
                try {
                    let saveData = true
                    this.onoffMap =false
                    let data = this.meetInfo
                    data.product = this.productArrayInfo
                    data.teams = this.teamArrayInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    data.location = this.meetInfo.location_name

                    if (data.key === '' || data.key ===undefined){
                        this.$message({
                            type:'error',
                            message:'请选择类型'
                        })
                        return
                    }
                    if (data.start_time === '' || data.start_time ===null || data.start_time ===null){
                        this.$message({
                            type:'error',
                            message:'请选择开始时间'
                        })
                        return
                    }
                    if (data.end_time === '' || data.end_time ===undefined || data.end_time === null){
                        this.$message({
                            type:'error',
                            message:'请选择结束时间'
                        })
                        return
                    }
                    if (data.campaign_name === '' || data.campaign_name ===undefined){
                        this.$message({
                            type:'error',
                            message:'请输入名称'
                        })
                        return
                    }
                    // if (data.teams.length === 0 || data.teams ===undefined){
                    //     this.$message({
                    //         type:'error',
                    //         message:'请添加执行人'
                    //     })
                    //     return
                    // }
                    if (data.status === 'APPROVED') {
                        this.$confirm('更改后需再次提交此计划, 确定保存?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                             http.post('/wapi/Conference/saveMeettingInfo',data).then(res=>{
                                if (res.success === true){


                                    if (this.status === 'NEW'){
                                        this.activity_id = res.data[0].activity_id
                                        //this.init()
                                        this.cordBool = false
                                        this.$router.push({
                                            name:'conference'
                                        })
                                    }else {

                                        this.data.lng = this.meetInfo.lng
                                        this.data.lat = this.meetInfo.lat
                                        this.init()
                                        this.onoffMap = true
                                        this.cordBool = false
                                        this.productArrayInfo = []
                                        this.teamArrayInfo = []
                                    }
                                }
                            })
                        }).catch(() => {
                            saveData = false
                            this.$message({
                                type: 'info',
                                message: '已取消保存'
                            });
                        });
                    }else {
                        await http.post('/wapi/Conference/saveMeettingInfo',data).then(res=>{
                            if (res.success === true){


                                if (this.status === 'NEW'){
                                    this.activity_id = res.data[0].activity_id
                                    //this.init()
                                    this.cordBool = false
                                    this.$router.push({
                                        name:'conference'
                                    })
                                }else {

                                    this.data.lng = this.meetInfo.lng
                                    this.data.lat = this.meetInfo.lat
                                    this.init()
                                    this.onoffMap = true
                                    this.cordBool = false
                                    this.productArrayInfo = []
                                    this.teamArrayInfo = []
                                }
                            }else {
                                this.$message({
                                    type: 'error',
                                    message: res.message,
                                })
                            }
                        })
                    }

                }catch (e) {

                }
            },
            closeCord(){
                if (this.status === 'NEW'){
                    this.$router.go(-1)
                } else {
                    this.meetInfo = JSON.parse(JSON.stringify(this.meetInfoCopy));
                    this.cordBool = false
                    this.data.lng = this.center[0]
                    this.data.lat = this.center[1]

                    this.onoffMap = true;
                    // this.$refs['formlist'].clearValidate();
                    this.$refs['formlist'].resetFields();
                }

            },
            handleBackClick(){
                this.$router.go(-1)
            },
           async btnRefuseClick(){
                let data = this.meetInfo
                data.tenant_id = this.$store.getters.getUser
                data.status = 'DENIED'
                await http.post('/wapi/Conference/submitMeetingPlan',data).then(res=>{
                    if (res.success === true){
                        if (res.data.success === false){
                            this.$message({
                                type:'error',
                                message:res.data.message
                            })
                        } else {

                            //this.init()
                            this.$message({
                                type:'success',
                                message:'已审批'
                            })
                            this.$router.push({
                                name:'conference'
                            })
                        }

                    }
                })
            },
            async btnAgreeClick(){
                let data = this.meetInfo
                data.tenant_id = this.$store.getters.getUser.tenant_id
                data.status = 'APPROVED'

                await http.post('/wapi/Conference/submitMeetingPlan',data).then(res=>{
                    if (res.success === true){
                        if (res.data.success === false){
                            this.$message({
                                type:'error',
                                message:res.data.message
                            })
                        } else {

                             //this.init()
                            this.$message({
                                type:'success',
                                message:'已审批'
                            })
                            this.$router.push({
                                name:'conference'
                            })
                        }

                    }
                })
            },
            async handleSubmitClick(){
                try {
                    let data = this.meetInfo
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.status = 'SUBMITTED'

                    if (!data.activity_id) {
                        this.$message({
                            type:'error',
                            message:'请先创建会议'
                        })
                        return false
                    }
                    if (data.key === '' || data.key ===undefined){
                        this.$message({
                            type:'error',
                            message:'请选择类型'
                        })
                        return false
                    }
                    if (data.start_time === '' || data.start_time ===null || data.start_time ===null){
                        this.$message({
                            type:'error',
                            message:'请选择开始时间'
                        })
                        return false
                    }
                    if (data.end_time === '' || data.end_time ===undefined || data.end_time === null){
                        this.$message({
                            type:'error',
                            message:'请选择结束时间'
                        })
                        return false
                    }
                    if (data.campaign_name === '' || data.campaign_name ===undefined){
                        this.$message({
                            type:'error',
                            message:'请输入名称'
                        })
                        return false
                    }
                    // if (data.teams.length === 0 || data.teams ===undefined){
                    //     this.$message({
                    //         type:'error',
                    //         message:'请添加执行人'
                    //     })
                    //     return false
                    // }

                    await http.post('/wapi/Conference/submitMeetingPlan',data).then(res=>{
                        if (res.success === true){
                            if (res.data.success === false){
                                this.$message({
                                    type:'error',
                                    message:res.data.message
                                })
                            } else {
                                //this.init()
                                this.$message({
                                    type:'success',
                                    message:'已提交'
                                })
                                this.$router.push({
                                    name:'conference'
                                })
                            }

                        }
                    })
                }catch (e) {

                }
            },
            async btnDeleteClick(){
                this.$confirm('确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try {
                        let data = this.meetInfo
                        data.tenant_id = this.$store.getters.getUser.tenant_id
                        await http.post('/wapi/Conference/delMeeting',data).then(res=>{
                            if (res.success === true){
                                this.$message({
                                    type:'success',
                                    message:'删除成功'
                                })
                                this.$router.go(-1)
                            }
                        })
                    }catch (e) {

                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
           async handleCompleteClick(){

                try {
                    let user = this.$store.getters.getUser
                    let data={
                       activity_id:this.activity_id,
                       tenant_id : user.tenant_id,
                       user_id : user.user_id,
                    }
                    await http.post('/wapi/Conference/completeMeetingPlan',data).then(res=>{
                        if (res.success === true){
                            this.$message({
                                type:'success',
                                message:'已审批'
                            })
                            //this.init()
                            this.$router.push({
                                name:'conference'
                            })

                        }
                    })



                }catch (e) {

                }
            },
            async delMeetingParticipant(item){

                this.$confirm('是否移除客户?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    try {
                        let data = item
                        data.tenant_id = this.$store.getters.getUser.tenant_id
                        data.user_id =this.$store.getters.getUser.user_id
                        data.campaign_id = this.activity_id ? this.activity_id : ''
                        data.type = ''
                        data.status = ''

                        data.status = ''
                        http.post('/wapi/Conference/delMeetingParticipant',data).then(res=>{
                            if (res.success === true){
                                this.$message({
                                    type:'success',
                                    message:'移除成功'
                                })
                                this.init()
                                this.getMeetingParticipant()

                            }
                        })

                    }catch (e) {
                        loading.close()
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            async deleteImgAgenda(id){

                this.$confirm('是否删除图片啊?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    try {
                        let user = this.$store.getters.getUser
                       let data={
                           tenant_id : user.tenant_id,
                           photo_id : id,
                           modified_by : user.user_id,
                           campaign_id : this.activity_id
                       }
                        http.post('/wapi/Conference/delMeetingAgendaPhoto',data).then(res=>{
                            if (res.success === true){
                                this.$message({
                                    type:'success',
                                    message:'删除成功'
                                })
                                this.dialogVisibleImg = false


                                for (let i=0;i<this.photoArrayAgenda.length;i++){
                                    if (this.photoArrayAgenda[i].id === id){
                                        this.photoArrayAgenda.splice(i,1)
                                        break
                                    }
                                }

                            }
                        })
                    }catch (e) {
                        loading.close()
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            async deleteImgAgenda_now(id){

                this.$confirm('是否删除图片啊?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    try {
                        let user = this.$store.getters.getUser
                        let data={
                            tenant_id : user.tenant_id,
                            photo_id : id,
                            modified_by : user.user_id,
                            campaign_id : this.activity_id
                        }

                        http.post('/wapi/Conference/delMeetingPhoto',data).then(res=>{
                            if (res.success === true){
                                this.$message({
                                    type:'success',
                                    message:'删除成功'
                                })
                                this.dialogVisibleImg_now = false

                                for (let i=0;i<this.photoArray.length;i++){
                                    if (this.photoArray[i].id === id){
                                        this.photoArray.splice(i,1)
                                        break
                                    }
                                }
                            }
                        })
                    }catch (e) {
                        loading.close()
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handlePictureCardPreview(file) {


                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            sortKey(array, key) {
                return array.sort(function(a, b) {
                    var x = a[key];
                    var y = b[key];
                    return x > y ? 1 : x < y ? -1 : 0;
                });
            },
        },
    }
</script>

<style scoped>
    /*#meetInfo {*/
    /*    background: #fff;*/
    /*    padding: 0px 50px;*/
    /*    height: 100%;*/
    /*    box-sizing: border-box;*/
    /*}*/
    #council >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    #coordinates >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    #change >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    #agenda >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    #estimates >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    #speak >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    #actual >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    #pictureAdd >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: right;
        font-weight: bold;
    }
    #AgendaAdd >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: right;
        font-weight: bold;
    }
    #estimates >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: right;
        font-weight: bold;
    }
    #estimates
    #meetInfo >>>.el-tag.el-tag--info{
        background: #FF9901;
        color: #FFFFFF;
        border: none;
    }
    #meetInfo{
        height: 100%;
    }
    #meetInfo >>>.el-tag.el-tag--info .el-tag__close{
        display: none;
    }
    #meetInfo >>>.el-tag.el-tag--info{
        background: #FF9901;
        color: #FFFFFF;
        border: none;
    }
    #meetInfo #travelSavePlanPs >>>.el-textarea__inner{
        height: 400px;
    }
    #meetInfo >>> .meetInfo_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
    #meetInfo >>> .el-input__inner::placeholder{
        text-align: left;
    }
    #meetInfo >>> .el-input-number.is-controls-right .el-input__inner {
        text-align: left;
    }
    #meetInfo >>> .conference_table_cell{
        color: #2b92fa !important;
    }
    #meetInfo >>> .el-button--warning {
        color: #FFF;
        background-color: #FF9901;
        border-color: #FF9901;
    }
    #meetInfo >>> .el-button--warning:hover {
        background: #ebb563;
        border-color: #ebb563;
        color: #FFF;
    }
    #meetInfo >>>.el-icon-edit-outline:before {
        font-size: 16px;
    }
    #meetInfo >>>.el-icon-edit-outline span{
        position: relative;
        top: -2px;
        font-size: 13px;
    }
    .el-button-group >>> .el-button{
        padding: 8px 18px;
    }
    .active{
        color: #409EFF;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
    }

</style>

<style>
    #meetInfo .el-dialog__header {
        padding: 0;
    }
    #meetInfo .dialogVisibleUp .el-dialog__header{
        padding: 20px 20px 10px;
    }
    #meetInfo .el-upload--picture-card{
        width: 130px;
        height: 130px;
    }
    #meetInfo #meetInfo_after{
         opacity: 0;
     }
    #meetInfo #meetInfo_after:hover{
        opacity: 1;
        z-index: 99;
        background: rgba(0,0,0,0.3);
        border-radius: 10px;
    }
    #meetInfo #meetInfo_afterAgenda{
        opacity: 0;
    }
    #meetInfo #meetInfo_afterAgenda:hover{
        opacity: 1;
        z-index: 99;
        background: rgba(0,0,0,0.3);
        border-radius: 10px;
    }
    #meetInfo .el-form-item__error{
        margin-left: 5%;
    }
    #meetInfo .meetInfo_label_info .el-form-item__error{
        margin-left: 0%;
    }
</style>




// WEBPACK FOOTER //
// src/pages/calendar/components/meetInfo.vue